import "./illus3.css";

const Illus3 = ({ visible = false }) => {
  return (
    <svg
      className="animated"
      id="freepik_stories-psychologist"
      version="1.1"
      viewBox="0 0 750 500"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        className="animable"
        id="freepik--background-complete--inject-18"
        style={{ transformOrigin: "375px 199.11px" }}
      >
        <path
          className="animable"
          id="elgy9q9xs5zk8"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "668.73px 81.15px",
          }}
          d="M682.23,81.12c0,1.87.12,3.75.13,5.65V87h-.28c-4.41,0-8.83.15-13.24.16l-13.24.06h-.5v-.5l.06-11.19v-.45h.44c2.23,0,4.47,0,6.7,0l6.66.11,13.12.28Zm-13.49-5.26-6.58.11c-2.19,0-4.37,0-6.55.06l.45-.45.05,11.19-.5-.5,13.24.07c4.41,0,8.83.11,13.24.16l-.27.27c0-1.83.08-3.67.13-5.53l.14-5.66Z"
        />
        <path
          className="animable"
          id="elbj9foxyx9mk"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "653.96px 67.07px",
          }}
          d="M667.46,67c0,1.87.11,3.75.13,5.65v.27h-.28c-4.41,0-8.83.15-13.24.16l-13.24.06h-.5v-.5l0-11.19V61h.44c2.23,0,4.47,0,6.69,0l6.66.11,13.13.28ZM654,61.75l-6.58.11c-2.18,0-4.36,0-6.54.06l.44-.45.06,11.19-.5-.5,13.24.07c4.41,0,8.83.11,13.24.16l-.27.27c0-1.83.08-3.67.13-5.53l.14-5.66Z"
        />
        <path
          className="animable"
          id="elbswi6r08rsq"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "463.62px 147.515px",
          }}
          d="M477.11,147.44c0,1.87.11,3.75.13,5.65v.27H477c-4.41,0-8.82.15-13.24.16l-13.24.06H450v-.5L450,141.9v-.45h.44c2.23,0,4.47,0,6.7,0l6.66.11,13.12.28Zm-13.5-5.26-6.58.11c-2.19.05-4.37,0-6.55.06l.45-.45.05,11.19-.5-.5,13.24.07c4.42,0,8.83.11,13.24.16l-.27.27c0-1.83.09-3.67.13-5.53l.14-5.66Z"
        />
        <path
          className="animable"
          id="elz48s6b6tmm"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "448.83px 133.415px",
          }}
          d="M462.33,133.33c.05,1.87.12,3.75.13,5.65v.27h-.28c-4.41.05-8.83.15-13.24.16l-13.24.06h-.5V139l.06-11.19v-.45h.44c2.23,0,4.47,0,6.7.05l6.66.11,13.12.28Zm-13.49-5.26-6.58.11c-2.19,0-4.37,0-6.55.06l.45-.45,0,11.19-.5-.5,13.24.07c4.41,0,8.83.11,13.24.16l-.27.27c0-1.83.08-3.67.13-5.53l.14-5.66Z"
        />
        <path
          className="animable"
          id="elzgpg9l7db6f"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "683.5px 67.07px",
          }}
          d="M697,67c0,1.87.11,3.75.13,5.65v.27h-.28c-4.41,0-8.82.15-13.24.16l-13.24.06h-.5v-.5l.06-11.19V61h.44c2.23,0,4.47,0,6.7,0l6.66.11,13.12.28Zm-13.5-5.26-6.58.11c-2.19,0-4.37,0-6.55.06l.45-.45,0,11.19-.5-.5,13.24.07c4.42,0,8.83.11,13.24.16l-.27.27c0-1.83.09-3.67.13-5.53l.14-5.66Z"
        />
        <path
          className="animable"
          id="elk3uc64uca5o"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "247.36px 249.59px",
          }}
          d="M233.87,249.67c-.05-1.86-.12-3.75-.13-5.65v-.27H234c4.41-.05,8.83-.16,13.24-.17l13.24-.06h.5v.5l-.06,11.19v.45h-.44c-2.23,0-4.47,0-6.7-.06l-6.66-.11L234,255.21Zm13.49,5.26,6.58-.11c2.19,0,4.37,0,6.55-.06l-.45.45L260,244l.5.5-13.24-.06c-4.41,0-8.83-.12-13.24-.17l.27-.27c0,1.83-.08,3.67-.13,5.54l-.14,5.65Z"
        />
        <path
          className="animable"
          id="elv0o3lqbrusp"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "81.27px 298.85px",
          }}
          d="M67.77,299c0-1.87-.12-3.76-.13-5.65V293h.28c4.41,0,8.83-.16,13.24-.16l13.24-.06h.5v.51l-.06,11.19v.44h-.44c-2.23,0-4.47,0-6.7-.05L81,304.77l-13.12-.27Zm13.49,5.26,6.58-.12c2.19,0,4.37,0,6.55-.05l-.45.45,0-11.19.5.5-13.24-.07c-4.41,0-8.83-.11-13.24-.16l.27-.27c0,1.83-.08,3.67-.13,5.53l-.14,5.66Z"
        />
        <path
          className="animable"
          id="elaz1nvenasx7"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "66.5px 313px",
          }}
          d="M53,313.07c0-1.87-.11-3.76-.13-5.65v-.27h.28c4.41-.05,8.82-.16,13.24-.16l13.24-.06h.5v.51l-.06,11.19v.44h-.44c-2.23,0-4.47,0-6.7-.05l-6.66-.12-13.12-.27Zm13.5,5.26,6.58-.12c2.19,0,4.37,0,6.55,0l-.45.45,0-11.19.5.49-13.24-.06c-4.42,0-8.83-.11-13.24-.16l.27-.27c0,1.83-.09,3.67-.13,5.53l-.14,5.66Z"
        />
        <path
          className="animable"
          id="el6looz9eor7x"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "668.74px 313px",
          }}
          d="M655.24,313.07c0-1.87-.11-3.76-.13-5.65v-.27h.27c4.42-.05,8.83-.16,13.24-.16l13.24-.06h.51v.51l-.05,11.19v.44h-.45c-2.23,0-4.46,0-6.69-.05l-6.66-.12-13.13-.27Zm13.5,5.26,6.58-.12c2.19,0,4.36,0,6.54,0l-.44.45,0-11.19.49.49-13.24-.06c-4.41,0-8.82-.11-13.24-.16l.28-.27c0,1.83-.09,3.67-.13,5.53l-.15,5.66Z"
        />
        <path
          className="animable"
          id="eld5np7hdouwb"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "81.14px 67.08px",
          }}
          d="M94.64,67c0,1.87.12,3.75.14,5.65v.27H94.5c-4.41,0-8.82.15-13.24.16L68,73.16h-.5v-.5l.06-11.19V61H68c2.23,0,4.47,0,6.7,0l6.66.11,13.12.28ZM81.15,61.75l-6.58.11c-2.19,0-4.37,0-6.55.06l.45-.45,0,11.19-.5-.5,13.24.07c4.42,0,8.83.11,13.24.16l-.27.27c0-1.83.09-3.67.13-5.53l.14-5.66Z"
        />
        <path
          className="animable"
          id="elbc6qpwcp6du"
          style={{
            fill: "rgb(166, 166, 166)",
            transformOrigin: "556.213px 87.214px",
          }}
          d="M552.45,71.49c8.2,8,9.58,20.46,7.85,31.34,0,.24-.43.18-.43-.06,0-2.47.08-4.93.07-7.37l-.12-.33a16.44,16.44,0,0,1-5.33-5.73c-1.37-2.69-1.91-5.73-3-8.55-.1-.27.19-.19.38-.05,5,3.68,6.58,7.64,8,12.93a44.44,44.44,0,0,0-.87-8.24,28.09,28.09,0,0,0-6.82-13.72C552.1,71.57,552.31,71.35,552.45,71.49Z"
        />
        <path
          className="animable"
          id="elrzx3eh2hcpa"
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "548.608px 70.374px",
          }}
          d="M550.91,72.43c-1.41,0-2.3,2.3-3.4,3a1,1,0,0,1-1.55-.25c-1.09-1.52.4-3.39,1.81-4.44A15.47,15.47,0,0,1,544.84,72a1,1,0,0,1-1.32-.79c-.47-2.07,2.13-3,3.91-3-.86-.6-3.34-2.23-2-3s4.25,1.53,5.2,2.3c1.39,1.13,3.06,2.83,3.12,4.6C553.8,74.13,552,72.86,550.91,72.43Z"
        />
        <path
          className="animable"
          id="elhp17cpiunc7"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "549.635px 70.0945px",
          }}
          d="M551.32,72.78c-1.81-.83-5.27.36-5.57-.33-.6-1.39,2.17-2.34,3.67-2.53-1.38-.37-4-1-3.93-2.29.09-1.62,4-.23,6,1.3,2.52,1.93,2.5,3.8,2.08,4.17C553,73.61,551.62,72.91,551.32,72.78Z"
        />
        <path
          className="animable"
          id="elpdbnn51842c"
          style={{
            fill: "rgb(166, 166, 166)",
            transformOrigin: "566.747px 86.2587px",
          }}
          d="M571.13,70.7c-8.5,7.71-10.35,20.07-9,31,0,.25.42.2.43,0,.1-2.47.12-4.93.22-7.37l.14-.33a16.49,16.49,0,0,0,5.54-5.51c1.47-2.64,2.12-5.66,3.28-8.43.11-.27-.18-.2-.38-.07-5.12,3.49-6.86,7.39-8.5,12.62a45.16,45.16,0,0,1,1.18-8.2,28.09,28.09,0,0,1,7.34-13.46A.15.15,0,0,0,571.13,70.7Z"
        />
        <path
          className="animable"
          id="elxxtlezr7rmc"
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "574.984px 69.7246px",
          }}
          d="M572.64,71.69c1.4.1,2.2,2.39,3.28,3.09a1.05,1.05,0,0,0,1.56-.19c1.15-1.48-.27-3.41-1.64-4.51a16.15,16.15,0,0,0,2.87,1.46,1,1,0,0,0,1.35-.74c.56-2.06-2-3.08-3.79-3.19.89-.57,3.43-2.11,2.14-3s-4.3,1.37-5.27,2.1c-1.44,1.08-3.17,2.71-3.3,4.47C569.68,73.28,571.53,72.08,572.64,71.69Z"
        />
        <path
          className="animable"
          id="el3xuj0gs3bnn"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "573.963px 69.3874px",
          }}
          d="M572.22,72c1.83-.75,5.25.56,5.57-.11.65-1.36-2.08-2.42-3.57-2.66,1.39-.32,4-.82,4-2.15,0-1.62-4-.38-6.09,1.08-2.59,1.83-2.64,3.69-2.24,4.08C570.46,72.79,571.91,72.15,572.22,72Z"
        />
        <path
          className="animable"
          id="el50d2zbw80v6"
          style={{
            fill: "rgb(166, 166, 166)",
            transformOrigin: "562.91px 82.8377px",
          }}
          d="M562.44,91.07a84.58,84.58,0,0,1-2.64,12.19.31.31,0,0,1-.6-.12c.56-3.76,1.58-7.45,2.14-11.2A56.15,56.15,0,0,0,562,80.43c-.36-6.33-2.08-13.07-6.21-18-.09-.12.1-.29.2-.18,8.27,9.65,6.95,21.48,6.95,22.54,1.17-4,2.37-8.57,6.8-12.64.2-.18.34-.09.31.21-.79,7.4-2.85,11.27-7.14,15.23C562.77,88.74,562.62,89.91,562.44,91.07Z"
        />
        <path
          className="animable"
          id="elnzzrqcqdbg8"
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "553.855px 59.3762px",
          }}
          d="M555.71,63.52c-1.49-.66-3.54,1.23-5,1.36a1.22,1.22,0,0,1-1.49-1c-.36-2.12,2.13-3.32,4.12-3.7-1.25-.08-2.48.26-3.71-.07a1.18,1.18,0,0,1-1-1.49c.54-2.39,3.71-2,5.58-1.19-.59-1-2.34-4-.57-4.17s3.63,3.72,4.23,5c.88,1.88,1.75,4.47.92,6.34C557.85,66.74,556.61,64.51,555.71,63.52Z"
        />
        <path
          className="animable"
          id="el6jr1j9jqklf"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "554.729px 60.4971px",
          }}
          d="M556,64.08c-1.45-1.75-5.64-2.27-5.61-3.13.08-1.74,3.44-1.34,5.08-.78-1.24-1.08-3.68-3-2.93-4.36.92-1.63,4.32,1.8,5.62,4.4,1.64,3.27.68,5.19.06,5.37C557.33,65.82,556.2,64.38,556,64.08Z"
        />
        <path
          className="animable"
          id="elauyp1foapwj"
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "560.43px 107.215px",
          }}
          d="M567.88,93.29l3.65,27.88h-22.2c.45-2.47,4.59-27.91,4.59-27.91Z"
        />
        <rect
          className="animable"
          height="203.96"
          id="elrlzlvv86f5"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "153.12px 155.19px",
          }}
          width="153.02"
          x="76.61"
          y="53.21"
        />
        <rect
          className="animable"
          height="90.72"
          id="el4e4o1q7u767"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "116.945px 106.74px",
          }}
          width="66.17"
          x="83.86"
          y="61.38"
        />
        <rect
          className="animable"
          height="90.72"
          id="el2w12tqgdz6t"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "189.295px 106.74px",
          }}
          width="66.17"
          x="156.21"
          y="61.38"
        />
        <rect
          className="animable"
          height="90.72"
          id="el842sz714iwg"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "116.945px 203.64px",
          }}
          width="66.17"
          x="83.86"
          y="158.28"
        />
        <rect
          className="animable"
          height="90.72"
          id="el1qw8k8k6erw"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "189.295px 203.64px",
          }}
          width="66.17"
          x="156.21"
          y="158.28"
        />
        <rect
          className="animable"
          height="291.8"
          id="eluf4052ewsn"
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "92.365px 199.11px",
          }}
          width="31.51"
          x="76.61"
          y="53.21"
        />
        <rect
          className="animable"
          height="18.17"
          id="eletlzcg5wby"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "667.285px 137.565px",
          }}
          width="7.31"
          x="663.63"
          y="128.48"
        />
        <rect
          className="animable"
          height="7.47"
          id="el214i2318j7m"
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "667.285px 132.215px",
          }}
          width="7.31"
          x="663.63"
          y="128.48"
        />
        <rect
          className="animable"
          height="18.17"
          id="eljc6get9xcus"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "546.645px 137.565px",
          }}
          width="7.31"
          x="542.99"
          y="128.48"
        />
        <rect
          className="animable"
          height="7.47"
          id="eltipag6tv6ke"
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "546.645px 132.215px",
          }}
          width="7.31"
          x="542.99"
          y="128.48"
        />
        <polygon
          className="animable"
          id="elokp3olgmci"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "102.145px 193.29px",
          }}
          points="102.14 67.09 102.39 98.64 102.48 130.19 102.64 193.29 102.48 256.39 102.39 287.94 102.14 319.49 101.9 287.94 101.81 256.39 101.65 193.29 101.81 130.19 101.9 98.64 102.14 67.09"
        />
        <polygon
          className="animable"
          id="eldgoowt1f3qs"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "87.68px 187.085px",
          }}
          points="87.68 74.4 87.92 102.57 88.06 130.75 88.18 187.09 88.06 243.43 87.92 271.6 87.68 299.77 87.43 271.6 87.29 243.43 87.18 187.09 87.3 130.75 87.44 102.57 87.68 74.4"
        />
        <polygon
          className="animable"
          id="eld28qaw0nxlj"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "94.91px 213px",
          }}
          points="94.91 81.05 95.15 114.04 95.24 147.03 95.41 213 95.24 278.97 95.16 311.96 94.91 344.95 94.67 311.96 94.58 278.97 94.41 213 94.58 147.03 94.67 114.04 94.91 81.05"
        />
        <polygon
          className="animable"
          id="el1jbxhj7r2p1"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "82.3px 206.85px",
          }}
          points="82.3 68.75 82.54 103.28 82.63 137.8 82.8 206.85 82.63 275.9 82.54 310.42 82.3 344.95 82.05 310.42 81.97 275.9 81.8 206.85 81.97 137.8 82.06 103.28 82.3 68.75"
        />
        <polygon
          className="animable"
          id="elk5e97c9xti8"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "204.1px 193.29px",
          }}
          points="204.1 67.09 204.34 98.64 204.43 130.19 204.6 193.29 204.43 256.39 204.34 287.94 204.1 319.49 203.85 287.94 203.76 256.39 203.6 193.29 203.77 130.19 203.85 98.64 204.1 67.09"
        />
        <polygon
          className="animable"
          id="elclg9u32dih5"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "218.56px 187.085px",
          }}
          points="218.56 74.4 218.81 102.57 218.95 130.75 219.06 187.09 218.95 243.43 218.81 271.6 218.56 299.77 218.32 271.6 218.18 243.43 218.06 187.09 218.18 130.75 218.32 102.57 218.56 74.4"
        />
        <polygon
          className="animable"
          id="el2w94qq24cuq"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "211.33px 213px",
          }}
          points="211.33 81.05 211.57 114.04 211.66 147.03 211.83 213 211.66 278.97 211.57 311.96 211.33 344.95 211.09 311.96 211 278.97 210.83 213 211 147.03 211.09 114.04 211.33 81.05"
        />
        <polygon
          className="animable"
          id="el2xihi2xe8xm"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "223.94px 206.85px",
          }}
          points="223.94 68.75 224.19 103.28 224.28 137.8 224.44 206.85 224.28 275.9 224.19 310.42 223.94 344.95 223.7 310.42 223.61 275.9 223.44 206.85 223.61 137.8 223.7 103.28 223.94 68.75"
        />
        <g id="elulcckr5iob">
          <rect
            className="animable"
            height="291.8"
            style={{
              fill: "rgb(219, 219, 219)",
              transformOrigin: "213.875px 199.11px",
              transform: "rotate(180deg)",
            }}
            width="31.51"
            x="198.12"
            y="53.21"
          />
        </g>
        <g id="elqvr0c5hx2w">
          <rect
            className="animable"
            height="7.31"
            style={{
              fill: "rgb(235, 235, 235)",
              transformOrigin: "606.965px 124.825px",
              transform: "rotate(180deg)",
            }}
            width="146.63"
            x="533.65"
            y="121.17"
          />
        </g>
        <g id="el7q1xiwptoum">
          <rect
            className="animable"
            height="11.73"
            style={{
              fill: "rgb(199, 199, 199)",
              transformOrigin: "648.425px 97.885px",
              transform: "rotate(90deg)",
            }}
            width="46.57"
            x="625.14"
            y="92.02"
          />
        </g>
        <g id="eluoaem9idj4">
          <rect
            className="animable"
            height="11.73"
            style={{
              fill: "rgb(219, 219, 219)",
              transformOrigin: "648.42px 74.665px",
              transform: "rotate(90deg)",
            }}
            width="5.12"
            x="645.86"
            y="68.8"
          />
        </g>
        <g id="el5z81cpc7l45">
          <rect
            className="animable"
            height="11.73"
            style={{
              fill: "rgb(219, 219, 219)",
              transformOrigin: "648.42px 84.735px",
              transform: "rotate(90deg)",
            }}
            width="1.9"
            x="647.47"
            y="78.87"
          />
        </g>
        <g id="els1g7zi3rtui">
          <rect
            className="animable"
            height="13.19"
            style={{
              fill: "rgb(219, 219, 219)",
              transformOrigin: "647.69px 112.505px",
              transform: "rotate(90deg)",
            }}
            width="5.12"
            x="645.13"
            y="105.91"
          />
        </g>
        <g id="eltqy1vpihej">
          <rect
            className="animable"
            height="8.2"
            style={{
              fill: "rgb(219, 219, 219)",
              transformOrigin: "638.465px 94.01px",
              transform: "rotate(90deg)",
            }}
            width="54.33"
            x="611.3"
            y="89.91"
          />
        </g>
        <g id="elnwctjyxzun9">
          <rect
            className="animable"
            height="4.92"
            style={{
              fill: "rgb(235, 235, 235)",
              transformOrigin: "638.495px 82.4px",
              transform: "rotate(90deg)",
            }}
            width="20.89"
            x="628.05"
            y="79.94"
          />
        </g>
        <g id="el8y98i7z7ehi">
          <rect
            className="animable"
            height="8.2"
            style={{
              fill: "rgb(199, 199, 199)",
              transformOrigin: "598.255px 99.17px",
              transform: "rotate(135.33deg)",
            }}
            width="54.33"
            x="571.09"
            y="95.07"
          />
        </g>
        <g id="elv86fasyfin">
          <rect
            className="animable"
            height="4.92"
            style={{
              fill: "rgb(219, 219, 219)",
              transformOrigin: "595.405px 101.94px",
              transform: "rotate(135.33deg)",
            }}
            width="20.89"
            x="584.96"
            y="99.48"
          />
        </g>
        <g id="elea7vr28wqmc">
          <rect
            className="animable"
            height="13.92"
            style={{
              fill: "rgb(166, 166, 166)",
              transformOrigin: "627.41px 100.55px",
              transform: "rotate(90deg)",
            }}
            width="41.26"
            x="606.78"
            y="93.59"
          />
        </g>
        <g id="el8nz1bozx9fn">
          <rect
            className="animable"
            height="13.92"
            style={{
              fill: "rgb(199, 199, 199)",
              transformOrigin: "627.405px 114.88px",
              transform: "rotate(90deg)",
            }}
            width="3.85"
            x="625.48"
            y="107.92"
          />
        </g>
        <g id="elw7vlrvck6zo">
          <rect
            className="animable"
            height="13.92"
            style={{
              fill: "rgb(199, 199, 199)",
              transformOrigin: "627.405px 109.69px",
              transform: "rotate(90deg)",
            }}
            width="1.49"
            x="626.66"
            y="102.73"
          />
        </g>
        <g id="elfan2mmacl9c">
          <rect
            className="animable"
            height="9.61"
            style={{
              fill: "rgb(166, 166, 166)",
              transformOrigin: "659.09px 101.785px",
              transform: "rotate(90deg)",
            }}
            width="38.78"
            x="639.7"
            y="96.98"
          />
        </g>
        <g id="elcd2wk6m5jzn">
          <rect
            className="animable"
            height="9.61"
            style={{
              fill: "rgb(199, 199, 199)",
              transformOrigin: "659.095px 115.255px",
              transform: "rotate(90deg)",
            }}
            width="3.61"
            x="657.29"
            y="110.45"
          />
        </g>
        <g id="elys0h29h78lq">
          <rect
            className="animable"
            height="9.61"
            style={{
              fill: "rgb(199, 199, 199)",
              transformOrigin: "659.095px 92.195px",
              transform: "rotate(90deg)",
            }}
            width="3.61"
            x="657.29"
            y="87.39"
          />
        </g>
        <g id="elwzdyanq9cqk">
          <rect
            className="animable"
            height="9.61"
            style={{
              fill: "rgb(199, 199, 199)",
              transformOrigin: "659.09px 97.185px",
              transform: "rotate(90deg)",
            }}
            width="1.4"
            x="658.39"
            y="92.38"
          />
        </g>
      </g>
      <g
        className="animable"
        id="freepik--Shadow--inject-18"
        style={{ transformOrigin: "375px 434.48px" }}
      >
        <ellipse
          className="animable"
          id="els7j0cyhguns"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "375px 434.48px",
          }}
          cx="375"
          cy="434.48"
          rx="306.75"
          ry="23.84"
        />
      </g>
      <g
        className="animable"
        id="freepik--Floor--inject-18"
        style={{ transformOrigin: "375px 363.26px" }}
      >
        <polygon
          className="animable"
          id="eltw53388grci"
          style={{ fill: "rgb(38, 50, 56)", transformOrigin: "375px 363.26px" }}
          points="52.21 363.26 132.91 363.02 213.6 362.93 375 362.76 536.4 362.93 617.09 363.02 697.79 363.26 617.09 363.51 536.4 363.59 375 363.76 213.6 363.59 132.91 363.5 52.21 363.26"
        />
      </g>
      <g
        className="animable"
        id="freepik--Lamp--inject-18"
        style={{ transformOrigin: "474.09px 221.48px" }}
      >
        <rect
          className="animable"
          height="5.83"
          id="el9wj0tgjxo4i"
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "474.09px 360.175px",
          }}
          width="51.08"
          x="448.55"
          y="357.26"
        />
        <rect
          className="animable"
          height="234.61"
          id="elk9vihcd2p4i"
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "474.095px 239.945px",
          }}
          width="6.05"
          x="471.07"
          y="122.64"
        />
        <rect
          className="animable"
          height="26.89"
          id="elx0viuzeh8m"
          style={{
            fill: "rgb(166, 166, 166)",
            transformOrigin: "474.095px 136.085px",
          }}
          width="6.05"
          x="471.07"
          y="122.64"
        />
        <polygon
          className="animable"
          id="elyqsx1n0ciwi"
          style={{
            fill: "rgb(0, 185, 143)",
            transformOrigin: "474.09px 110.17px",
          }}
          points="506.13 140.47 442.05 140.47 446.7 125.11 446.87 124.56 460.42 79.87 487.75 79.87 501.31 124.57 501.31 124.58 501.46 125.09 506.13 140.47"
        />
        <polygon
          className="animable"
          id="elf4twabgywdh"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "474.08px 129.16px",
          }}
          points="503.68 132.43 444.48 132.43 446.46 125.89 501.7 125.89 503.68 132.43"
        />
        <polygon
          className="animable"
          id="eldvglh3gqs2h"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "474.09px 120.135px",
          }}
          points="500.46 121.77 447.72 121.77 448.71 118.5 499.47 118.5 500.46 121.77"
        />
      </g>
      <g
        className="animable"
        id="freepik--Pictures--inject-18"
        style={{ transformOrigin: "352.12px 128.125px" }}
      >
        <rect
          className="animable"
          height="67.18"
          id="el76c7gtaxzv7"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "321.76px 86.8px",
          }}
          width="55.38"
          x="294.07"
          y="53.21"
        />
        <rect
          className="animable"
          height="54.92"
          id="elwthvkkn8f6"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "321.765px 86.81px",
          }}
          width="42.73"
          x="300.4"
          y="59.35"
        />
        <rect
          className="animable"
          height="54.92"
          id="elhoglgpp4e1b"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "301.235px 86.81px",
          }}
          width="1.67"
          x="300.4"
          y="59.35"
        />
        <rect
          className="animable"
          height="67.18"
          id="el921a53nhjvp"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "350.285px 86.8px",
          }}
          width="1.67"
          x="349.45"
          y="53.21"
        />
        <rect
          className="animable"
          height="30.01"
          id="elo64jt0d3d3t"
          style={{
            fill: "rgb(0, 185, 143)",
            transformOrigin: "319.755px 81.925px",
          }}
          width="10.07"
          x="314.72"
          y="66.92"
        />
        <rect
          className="animable"
          height="67.18"
          id="eleng90a4q83n"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "380.8px 169.45px",
          }}
          width="55.38"
          x="353.11"
          y="135.86"
        />
        <rect
          className="animable"
          height="54.92"
          id="el516wkr3d8ie"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "380.805px 169.45px",
          }}
          width="42.73"
          x="359.44"
          y="141.99"
        />
        <rect
          className="animable"
          height="54.92"
          id="elp2df7w10m4"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "360.275px 169.45px",
          }}
          width="1.67"
          x="359.44"
          y="141.99"
        />
        <rect
          className="animable"
          height="67.18"
          id="elg4cjaenadk5"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "409.335px 169.45px",
          }}
          width="1.67"
          x="408.5"
          y="135.86"
        />
        <rect
          className="animable"
          height="21.82"
          id="elms347x1hhb8"
          style={{
            fill: "rgb(0, 185, 143)",
            transformOrigin: "380.985px 167.09px",
          }}
          width="8.63"
          x="376.67"
          y="156.18"
        />
        <path
          className="animable"
          id="elu4mevdxbjgm"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "323.75px 94.705px",
          }}
          d="M337.68,102.56H309.82V86.85h27.86Zm-26.86-1h25.86V87.85H310.82Z"
        />
        <path
          className="animable"
          id="eljmgoq6fcqrq"
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "382.795px 177px",
          }}
          d="M394.89,185H370.7V169h24.19Zm-23.19-1h22.19V170H371.7Z"
        />
      </g>
      <g
        className="animable"
        id="freepik--Plant--inject-18"
        style={{ transformOrigin: "93.845px 268.71px" }}
      >
        <path
          className="animable"
          id="els9ncwjh7eco"
          style={{
            fill: "rgb(0, 185, 143)",
            transformOrigin: "83.8562px 203.655px",
          }}
          d="M91.36,217.44s-20.47-2.86-15.68-27.57C75.68,189.87,98.55,195,91.36,217.44Z"
        />
        <path
          className="animable"
          id="eli2eq2dxdgoh"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "85.3874px 210.963px",
          }}
          d="M90.33,212.29a38.28,38.28,0,0,0-1.4-3.69c0-.15,0-.31-.05-.46,0-.34-.06-.68-.08-1q-.09-1.11-.15-2.22c-.09-1.47-.18-3-.21-4.43a.06.06,0,1,0-.12,0c0,1.47,0,3,0,4.43,0,.74.07,1.48.12,2.21,0,.17,0,.33,0,.5a43.56,43.56,0,0,0-4.11-7,35.81,35.81,0,0,0-2.24-2.84c-.81-.93-1.67-1.82-2.5-2.75-.05-.06-.14,0-.08.09a37.47,37.47,0,0,1,3.94,5.25c.62.94,1.21,1.91,1.77,2.89l-.19-.08-.73-.29c-.56-.22-1.11-.43-1.67-.63-1.1-.41-2.2-.81-3.3-1.23-.06,0-.11.09,0,.12,1.09.43,2.16.89,3.24,1.35l1.59.68c.26.12.53.23.79.33a2.27,2.27,0,0,0,.55.2c.41.74.82,1.48,1.2,2.24a54.62,54.62,0,0,1,2.5,5.9l.14.42a12.82,12.82,0,0,0-1.67-.81l-2.12-1c-1.44-.66-2.86-1.33-4.24-2.11-.07,0-.13.07-.06.11,1.41.77,2.79,1.59,4.19,2.35.71.38,1.42.76,2.14,1.1a6.5,6.5,0,0,0,1.92.77,24.16,24.16,0,0,1,1.34,5.81c.23,2.79.2,5.61.27,8.41a0,0,0,1,0,.07,0c.21-2.54.32-5.11.33-7.65A22.11,22.11,0,0,0,90.33,212.29Z"
        />
        <path
          className="animable"
          id="eldguqk7u5i7t"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "87.1249px 199.911px",
          }}
          d="M87.18,197.76a24.35,24.35,0,0,0-.21,4.35,0,0,0,1,0,.06,0c.09-1.44.1-2.88.27-4.32C87.31,197.71,87.18,197.68,87.18,197.76Z"
        />
        <path
          className="animable"
          id="el4j1dimbk6e"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "79.9676px 198.4px",
          }}
          d="M81.32,199a15.63,15.63,0,0,1-2.63-1.29c-.07,0-.13.07-.06.11a9.86,9.86,0,0,0,2.66,1.27S81.37,199,81.32,199Z"
        />
        <path
          className="animable"
          id="el5lhh6p1qbtm"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "91.265px 247.911px",
          }}
          d="M92,256.67c0-2.26-.05-4.52-.08-6.78q-.06-11.28-.24-22.54-.16-8.94-.42-17.88a.09.09,0,0,0,0-.08c0-1.63,0-3.26,0-4.89,0,0,0-.06-.1-.06s-.1,0-.1.07l0,4.89s0,0,0,.07c-.3,10.61-.57,21.23-.63,31.84,0,2.16,0,4.32,0,6.48-.07,6.92-.11,13.84-.08,20.76,0,1.1,0,2.2,0,3.3,0,6.34.06,12.67.06,19,0,.34.38.51.78.53s.95-.17.95-.56c0-7,.05-14,.05-20.95C92,265.47,92.05,261.07,92,256.67Z"
        />
        <path
          className="animable"
          id="eltq77b33x5ol"
          style={{
            fill: "rgb(0, 185, 143)",
            transformOrigin: "68.477px 258.649px",
          }}
          d="M83.47,249.8s-9.85-7.29-19.19-2.37-10.81,23.93-10.81,23.93,13.72,2,22.36-6.26C84.16,257.18,83.47,249.8,83.47,249.8Z"
        />
        <path
          className="animable"
          id="els5cbofeopsb"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "75.3026px 257.575px",
          }}
          d="M86.15,250.25a11.75,11.75,0,0,0-5.7-.74,8.13,8.13,0,0,0-1.21-.12l-1.39-.11-2.87-.2c-1.94-.14-3.89-.26-5.83-.46-.06,0-.08.12,0,.13,1.92.24,3.83.51,5.75.71,1,.1,2,.2,3,.27l.72.07-.87.22a22.92,22.92,0,0,0-4.46,1.81c-.78.14-1.55.36-2.31.54-1.22.28-2.43.6-3.64.91-2.39.63-4.75,1.33-7.13,2-.07,0,0,.13,0,.11,2.37-.58,4.75-1.11,7.13-1.67l3.46-.83.9-.21a28.69,28.69,0,0,0-7,6.08,38.14,38.14,0,0,0-4.87,7.67c0,.07.07.14.11.07a37.25,37.25,0,0,1,5.88-7.73l-.12.4c-.19.58-.37,1.16-.55,1.74q-.55,1.72-1.08,3.48c0,.08.09.1.12,0,.42-1.13.81-2.26,1.21-3.39.19-.55.39-1.1.58-1.66l.3-.86c0-.09.06-.18.09-.27a34.91,34.91,0,0,1,3.49-3,26.85,26.85,0,0,1,5.23-3c0,.17-.07.34-.1.51-.1.44-.2.89-.29,1.34-.19.93-.38,1.87-.56,2.8-.37,1.91-.6,3.84-1,5.74,0,.08.11.11.13,0,.44-1.91,1-3.8,1.43-5.72q.33-1.44.63-2.88c.1-.45.19-.9.28-1.35,0-.25.11-.5.14-.76l.53-.22a15.57,15.57,0,0,1,8.19-1.12,8.08,8.08,0,0,1,5.93,4.75c.09.21.42.08.37-.14A7.61,7.61,0,0,0,86.15,250.25Z"
        />
        <path
          className="animable"
          id="el0kgbx71k2skq"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "70.381px 262.031px",
          }}
          d="M71.08,258.36c-.28,1.25-.56,2.5-.83,3.75a28.14,28.14,0,0,0-.69,3.64s.07,0,.08,0a28.54,28.54,0,0,0,.84-3.66l.72-3.7A.06.06,0,1,0,71.08,258.36Z"
        />
        <path
          className="animable"
          id="el9k015c3qew4"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "59.657px 262.533px",
          }}
          d="M61.56,261.53c-1.26.64-2.47,1.36-3.78,1.88-.08,0,0,.16,0,.12a40.53,40.53,0,0,0,3.76-1.95S61.59,261.52,61.56,261.53Z"
        />
        <path
          className="animable"
          id="eldyez0vjlsgm"
          style={{
            fill: "rgb(0, 185, 143)",
            transformOrigin: "74.6486px 223.21px",
          }}
          d="M85.68,236.4s-12,.77-17.63-7.16S63.71,210,63.71,210s12.64,1.54,17.66,7.24S85.68,236.4,85.68,236.4Z"
        />
        <path
          className="animable"
          id="elqkpyse65j2n"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "79.7817px 231.501px",
          }}
          d="M91.33,248.28c-.42-1.29-.94-2.56-1.42-3.83s-1-2.41-1.5-3.6a72.64,72.64,0,0,0-3.61-7.09c-.84-1.46-1.75-2.88-2.69-4.28,0-.21-.06-.43-.09-.64-.06-.37-.11-.75-.17-1.12-.12-.76-.26-1.52-.38-2.28-.28-1.66-.62-3.31-.89-5,0-.07-.13-.07-.12,0,.24,1.64.41,3.29.64,4.93.11.81.21,1.62.34,2.42,0,.3.09.59.13.88A83.44,83.44,0,0,0,75.62,221l-.88-1c0-.09-.07-.18-.11-.27l-.26-.69c-.18-.48-.35-1-.52-1.43-.34-.95-.64-1.9-.9-2.87,0-.07-.14,0-.12,0,.25,1,.5,2,.79,2.95.14.47.3.94.46,1.4l.09.23c-1.54-1.68-3.14-3.29-4.76-4.89a.06.06,0,1,0-.09.09A87.39,87.39,0,0,1,77.85,225a7.43,7.43,0,0,0-.9-.23c-.92-.18-1.86-.31-2.79-.43-2-.25-3.92-.5-5.87-.81-.08,0-.11.11,0,.13,1.86.36,3.71.78,5.56,1.21.88.2,1.75.37,2.63.54a16.65,16.65,0,0,1,2.12.61l.58.83c.89,1.28,1.73,2.59,2.56,3.92-.4-.09-.81-.16-1.22-.24-.93-.18-1.87-.35-2.8-.51-1.83-.3-3.67-.62-5.49-1-.07,0-.1.1,0,.12,1.84.43,3.67.94,5.49,1.42.88.24,1.77.45,2.66.65l1.34.29a2.77,2.77,0,0,0,.54.09q2.64,4.27,4.94,8.75c.67,1.31,1.31,2.63,1.94,4s1.19,2.76,1.79,4.15C91,248.69,91.43,248.58,91.33,248.28Z"
        />
        <path
          className="animable"
          id="elg4izibhdfgv"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "78.829px 220.577px",
          }}
          d="M79,220.62c-.23-1.14-.47-2.29-.72-3.43,0-.08-.14,0-.12,0,.22,1.13.44,2.26.65,3.39A31.41,31.41,0,0,0,79.5,224s0,0,0,0A24,24,0,0,0,79,220.62Z"
        />
        <path
          className="animable"
          id="elyxcxykm91t"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "70.1644px 219.595px",
          }}
          d="M72,220.29c-.55-.28-1.14-.5-1.73-.73l-.91-.36-.46-.18a2.15,2.15,0,0,1-.51-.23c-.09-.06-.15.1-.06.11a2.57,2.57,0,0,1,.52.21l.45.2.88.4a18.26,18.26,0,0,0,1.78.7A.06.06,0,0,0,72,220.29Z"
        />
        <path
          className="animable"
          id="eleazurrfg81j"
          style={{
            fill: "rgb(0, 185, 143)",
            transformOrigin: "116.11px 221.955px",
          }}
          d="M98,226.94s7.28-13.6,18.36-15.7,17.86,9.29,17.86,9.29-8.08,10.32-18.25,12.12S98,226.94,98,226.94Z"
        />
        <path
          className="animable"
          id="elh76t9mofmp4"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "107.202px 227.064px",
          }}
          d="M123.78,217.33a30.13,30.13,0,0,0-8.69.1l.5-.26,2.46-1.27c1.7-.88,3.42-1.82,5.2-2.54a.06.06,0,1,0,0-.11c-1.74.81-3.53,1.48-5.27,2.28-.87.4-1.73.82-2.57,1.27-.55.29-1.15.56-1.69.91a30.49,30.49,0,0,0-7,2.34l1.38-1.51c1-1.13,2-2.32,3.18-3.35.06-.05,0-.14-.09-.08-1.16,1-2.38,2-3.5,3.12-.55.53-1.07,1.08-1.58,1.65-.25.28-.51.57-.75.87a29.17,29.17,0,0,0-14.85,20.06c0,.07.09.12.12,0a33.43,33.43,0,0,1,8.14-13.78,32,32,0,0,1,14.84-8.59,32.46,32.46,0,0,1,10.25-.93C123.91,217.56,123.92,217.35,123.78,217.33Z"
        />
        <path
          className="animable"
          id="ell9vwglst7oo"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "115.084px 214.321px",
          }}
          d="M117.35,212.48a26.86,26.86,0,0,0-2.46,1.63,15.83,15.83,0,0,0-2.14,1.95c-.06.06,0,.15.1.09.73-.64,1.47-1.28,2.23-1.88a23.69,23.69,0,0,1,2.33-1.68C117.48,212.55,117.42,212.44,117.35,212.48Z"
        />
        <path
          className="animable"
          id="elb1uafsckhj"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "122.205px 215.356px",
          }}
          d="M123.43,214.78c-.41.18-.83.32-1.24.49l-1.24.52c-.08,0,0,.18,0,.14l1.23-.5c.42-.17.82-.36,1.23-.53C123.54,214.87,123.5,214.75,123.43,214.78Z"
        />
        <path
          className="animable"
          id="el28dbuhj31fl"
          style={{
            fill: "rgb(0, 185, 143)",
            transformOrigin: "113.845px 252.979px",
          }}
          d="M96.54,244.06s1.95,13.49,12.1,18.21,22.51,0,22.51,0S126.29,233.08,96.54,244.06Z"
        />
        <path
          className="animable"
          id="elywjdgn2q7ur"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "107.43px 251.973px",
          }}
          d="M124.16,253.5c-.94-.11-1.87-.27-2.79-.44L120,252.8l-.71-.14-.82-.76a41.11,41.11,0,0,0-6.21-4.5,36.06,36.06,0,0,0-3.71-1.91h.19l3.34.15c2.22.1,4.45.15,6.68.29.08,0,.07-.12,0-.12-2.23-.15-4.45-.4-6.68-.59l-3.25-.29-1.67-.15-.43,0c-.58-.22-1.16-.42-1.75-.6a15.71,15.71,0,0,0-8.59-.48c-2.56.66-5.1,2.33-5.76,5,0,.09.12.16.16.06,1-2.25,3.44-3.38,5.7-3.85a13.86,13.86,0,0,1,4.59-.09,11.07,11.07,0,0,0,.51,2c.29,1,.56,1.9.85,2.85.58,1.9,1.21,3.77,1.77,5.67,0,.08.14,0,.12,0-.47-1.9-.87-3.81-1.33-5.71q-.33-1.4-.69-2.79a14.26,14.26,0,0,0-.51-1.91,21.11,21.11,0,0,1,2.64.62,36.6,36.6,0,0,1,4.59,1.68c.15,1,.37,1.92.59,2.86.28,1.2.59,2.38,1,3.54a.06.06,0,0,0,.12,0c0-.08,0-.15,0-.23h0c-.23-1.1-.47-2.2-.7-3.3-.19-.89-.36-1.79-.56-2.67a40.06,40.06,0,0,1,3.7,1.87c0,.28.09.56.13.81l.24,1.38c.2,1,.4,2.08.65,3.11a48.23,48.23,0,0,0,1.75,5.87.06.06,0,0,0,0,.08l.06.06c0,.05.11,0,.1-.06-.47-2-1-4-1.45-6-.22-1-.44-2-.64-3-.1-.5-.19-1-.29-1.51,0-.14,0-.3-.07-.45a42.54,42.54,0,0,1,10,8.15c.07.09.22,0,.15-.12a37.52,37.52,0,0,0-2.42-2.95c-.51-.54-1-1.07-1.58-1.59l.17,0c.48.08,1,.15,1.43.21.94.13,1.88.22,2.82.33C124.21,253.63,124.24,253.51,124.16,253.5Z"
        />
        <path
          className="animable"
          id="elyj6dl7hta5"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "116.58px 256.297px",
          }}
          d="M117,258.07h0l-.06-.35c0-.15-.1-.29-.12-.44h0c-.21-.91-.39-1.81-.55-2.73,0-.06-.11,0-.11,0a10.89,10.89,0,0,0,.77,3.52s.08,0,.07,0Z"
        />
        <path
          className="animable"
          id="el2eiphnx60ki"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "107.664px 254.352px",
          }}
          d="M108.54,257.86a.06.06,0,0,0-.06-.06c-.29-1.2-.56-2.39-.81-3.59-.13-.64-.26-1.27-.38-1.9-.07-.34-.13-.69-.19-1a3,3,0,0,0-.22-.88.06.06,0,0,0-.11,0,5.86,5.86,0,0,0,.25,1.81c.13.66.25,1.32.4,2,.29,1.34.63,2.66,1,4a.07.07,0,0,0,.14,0Z"
        />
        <path
          className="animable"
          id="el4z2rin0dri9"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "120.444px 249.295px",
          }}
          d="M123.24,249.61c-1.86-.25-3.71-.52-5.57-.75-.07,0-.11.11,0,.13,1.85.27,3.71.5,5.57.74C123.28,249.74,123.32,249.62,123.24,249.61Z"
        />
        <path
          className="animable"
          id="elisovvrpwjz"
          style={{
            fill: "rgb(0, 185, 143)",
            transformOrigin: "103.075px 193.29px",
          }}
          d="M91.35,212.42s-6.21-27.24,23.05-38.26C114.4,174.16,122.51,210,91.35,212.42Z"
        />
        <path
          className="animable"
          id="elqqtx0lsbf1"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "100.256px 200.939px",
          }}
          d="M97.66,197l.32-.19,1.65-.93L103,194c2.23-1.25,4.43-2.54,6.68-3.77a.06.06,0,1,0-.06-.1c-2.26,1.22-4.55,2.37-6.81,3.57l-3.36,1.77-1.37.72c1-1.85,2-3.66,3.17-5.41,1.53-2.33,3.2-4.56,5-6.73a.1.1,0,0,0-.15-.14,47,47,0,0,0-6.77,8.3c0-.1,0-.2,0-.29,0-.67.05-1.35.06-2,0-1.33,0-2.66,0-4,0-.08-.12-.08-.13,0,0,1.31-.21,2.62-.28,3.92,0,.66-.07,1.31-.09,2,0,.36,0,.76,0,1.15-.6,1-1.18,1.93-1.73,2.91a52.14,52.14,0,0,0-2.61,5.49c0-.68-.07-1.36-.11-2-.09-1.5-.27-3-.33-4.47,0-.08-.13-.08-.13,0,0,1.49,0,3,0,4.48,0,.74,0,1.49.09,2.23,0,.28,0,.55,0,.83a50.11,50.11,0,0,0-2.21,7.49A81.47,81.47,0,0,0,90.79,218s0,0,0,0a43.85,43.85,0,0,1,1.55-7.33c.36-1.29.74-2.57,1.15-3.83,1.22-.58,2.39-1.29,3.56-2l3.68-2c2.44-1.34,4.88-2.71,7.4-3.89.07,0,0-.14-.07-.11-2.55,1.16-5.12,2.26-7.63,3.52-1.25.62-2.47,1.29-3.69,2-1,.57-2.06,1.14-3,1.8q.42-1.28.9-2.52C95.54,201.41,96.55,199.16,97.66,197Z"
        />
        <path
          className="animable"
          id="ela7rm9kforlf"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "95.3px 193.075px",
          }}
          d="M95.2,190.74c0-.08-.13-.08-.13,0,.11,1.56.16,3.11.32,4.66a.07.07,0,0,0,.14,0C95.48,193.84,95.31,192.29,95.2,190.74Z"
        />
        <path
          className="animable"
          id="eld7ebu4elcik"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "106.509px 197.083px",
          }}
          d="M109.23,195.94c-1.84.74-3.68,1.44-5.51,2.2,0,0,0,.11,0,.09,1.85-.7,3.67-1.45,5.51-2.17C109.34,196,109.3,195.91,109.23,195.94Z"
        />
        <path
          className="animable"
          id="el2qglxfh31v6"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "109.434px 184.841px",
          }}
          d="M112,183.38a49.16,49.16,0,0,0-5.21,2.79.08.08,0,0,0,.09.13c1.69-1,3.42-1.94,5.18-2.81C112.15,183.45,112.08,183.35,112,183.38Z"
        />
        <g id="elxvjez363r3">
          <path
            className="animable"
            style={{ opacity: "0.1", transformOrigin: "83.8562px 203.655px" }}
            d="M91.36,217.44s-20.47-2.86-15.68-27.57C75.68,189.87,98.55,195,91.36,217.44Z"
          />
        </g>
        <g id="elcsdezrw030g">
          <path
            className="animable"
            style={{ opacity: "0.1", transformOrigin: "116.45px 225.981px" }}
            d="M134.22,220.53s-8.08,10.32-18.25,12.12C108.21,234,101.83,230,99.24,228l-.56-.92s5.25-4.42,15.17-7S134.22,220.53,134.22,220.53Z"
          />
        </g>
        <rect
          className="animable"
          height="44.49"
          id="elygwkt90fh5"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "90.465px 293.565px",
          }}
          width="42.21"
          x="69.36"
          y="271.32"
        />
        <rect
          className="animable"
          height="76.2"
          id="eljpsj08w5jj8"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "67.54px 325.16px",
          }}
          width="2.16"
          x="66.46"
          y="287.06"
        />
        <rect
          className="animable"
          height="76.2"
          id="elzxn220txvl"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "113.16px 325.16px",
          }}
          width="2.16"
          x="112.08"
          y="287.06"
        />
        <rect
          className="animable"
          height="76.2"
          id="elr87qchmr9r"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "91.5px 325.16px",
          }}
          width="2.16"
          x="90.42"
          y="287.06"
        />
        <rect
          className="animable"
          height="6.16"
          id="el2mqxqbgx1yz"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "90.355px 316.03px",
          }}
          width="45.63"
          x="67.54"
          y="312.95"
        />
      </g>
      <g
        className="animable"
        id="freepik--Divan--inject-18"
        style={{ transformOrigin: "275.23px 341.34px" }}
      >
        <polygon
          className="animable"
          id="elm5urb328cp"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "285.895px 364.73px",
          }}
          points="268.1 415.16 275.12 415.16 303.69 314.3 268.1 314.3 268.1 415.16"
        />
        <polygon
          className="animable"
          id="eldc688knj93f"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "432.535px 301.935px",
          }}
          points="400.49 363.4 432.57 363.4 464.58 253.96 435.21 240.47 400.49 363.4"
        />
        <polygon
          className="animable"
          id="eleeusjw1rkyg"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "362.45px 301.935px",
          }}
          points="289.69 363.4 400.49 363.4 435.21 240.47 324.41 240.47 289.69 363.4"
        />
        <polygon
          className="animable"
          id="eliptxukdd6a"
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "436.275px 428.685px",
          }}
          points="430.5 415.16 431.16 423.33 432.71 442.21 439.83 442.21 441.38 423.33 442.05 415.16 430.5 415.16"
        />
        <polygon
          className="animable"
          id="elssr2bhr0r5"
          style={{
            fill: "rgb(166, 166, 166)",
            transformOrigin: "436.275px 419.245px",
          }}
          points="442.05 415.16 430.5 415.16 431.16 423.33 441.38 423.33 442.05 415.16"
        />
        <polygon
          className="animable"
          id="el1qv2jk0ae02"
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "343.58px 428.685px",
          }}
          points="337.8 415.16 338.47 423.33 340.02 442.21 347.14 442.21 348.69 423.33 349.36 415.16 337.8 415.16"
        />
        <polygon
          className="animable"
          id="el30ta80qaabp"
          style={{
            fill: "rgb(166, 166, 166)",
            transformOrigin: "343.58px 419.245px",
          }}
          points="349.36 415.16 337.8 415.16 338.47 423.33 348.69 423.33 349.36 415.16"
        />
        <polygon
          className="animable"
          id="elohl3s6i36k"
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "191.465px 428.685px",
          }}
          points="185.69 415.16 186.35 423.33 187.91 442.21 195.02 442.21 196.58 423.33 197.24 415.16 185.69 415.16"
        />
        <polygon
          className="animable"
          id="elzcly9czier"
          style={{
            fill: "rgb(166, 166, 166)",
            transformOrigin: "191.465px 419.245px",
          }}
          points="197.24 415.16 185.69 415.16 186.35 423.33 196.58 423.33 197.24 415.16"
        />
        <polygon
          className="animable"
          id="el2kxl3jd0smk"
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "98.775px 428.685px",
          }}
          points="93 415.16 93.66 423.33 95.21 442.21 102.33 442.21 103.88 423.33 104.55 415.16 93 415.16"
        />
        <polygon
          className="animable"
          id="eljt09i3hpbn"
          style={{
            fill: "rgb(166, 166, 166)",
            transformOrigin: "98.775px 419.245px",
          }}
          points="104.55 415.16 93 415.16 93.66 423.33 103.88 423.33 104.55 415.16"
        />
        <g id="el0fyvg8wy0an7">
          <rect
            className="animable"
            height="100.86"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "254.595px 364.73px",
              transform: "rotate(180deg)",
            }}
            width="27.01"
            x="241.09"
            y="314.3"
          />
        </g>
        <g id="elramex8kpr08">
          <rect
            className="animable"
            height="74.64"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "259.355px 377.84px",
              transform: "rotate(180deg)",
            }}
            width="346.95"
            x="85.88"
            y="340.52"
          />
        </g>
        <g id="elpu0zcgx2qz">
          <rect
            className="animable"
            height="74.64"
            style={{
              fill: "rgb(55, 71, 79)",
              transformOrigin: "318.5px 377.84px",
              transform: "rotate(180deg)",
            }}
            width="228.66"
            x="204.17"
            y="340.52"
          />
        </g>
        <g id="eltklek6ozlvc">
          <rect
            className="animable"
            height="100.86"
            style={{
              fill: "rgb(69, 90, 100)",
              transformOrigin: "413.995px 364.73px",
              transform: "rotate(180deg)",
            }}
            width="27.01"
            x="400.49"
            y="314.3"
          />
        </g>
        <path
          className="animable"
          id="ellrpqky3uxf"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "268.1px 361.69px",
          }}
          d="M268.1,314.3c-.21,7.9-.31,15.8-.39,23.7l-.12,23.69.12,23.7.14,11.84.25,11.85.25-11.85.14-11.84.12-23.7L268.49,338C268.41,330.1,268.31,322.2,268.1,314.3Z"
        />
        <path
          className="animable"
          id="elwfa9d9lymsl"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "145.08px 363.405px",
          }}
          d="M85.88,363.4c4,.21,8.05.31,12.08.39l12.08.12,82.24-.11,6-.15,6-.25-6-.24-6-.15L110,362.9,98,363C93.93,363.1,89.9,363.19,85.88,363.4Z"
        />
        <path
          className="animable"
          id="el2dq2k1pxpsy"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "318.595px 363.4px",
          }}
          d="M204.36,363.4c7.76.21,15.53.31,23.29.39l23.29.12,158.6-.11,11.65-.15,11.64-.25-11.64-.24L409.54,363l-158.6-.11-23.29.11C219.89,363.1,212.12,363.19,204.36,363.4Z"
        />
        <path
          className="animable"
          id="elo0gp1xg2qyf"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "400.51px 361.69px",
          }}
          d="M400.49,314.3c-.21,7.9-.31,15.8-.39,23.7L400,361.69l.12,23.7.14,11.84.25,11.85.25-11.85.14-11.84.12-23.7L400.88,338C400.8,330.1,400.7,322.2,400.49,314.3Z"
        />
        <rect
          className="animable"
          height="100.86"
          id="elb2jbpqygpu7"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "444.22px 364.73px",
          }}
          width="33.44"
          x="427.5"
          y="314.3"
        />
      </g>
      <g
        className="animable"
        id="freepik--character-2--inject-18"
        style={{ transformOrigin: "572.705px 294.316px" }}
      >
        <polygon
          className="animable"
          id="el8i7mup6ftjd"
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "546.785px 365.44px",
          }}
          points="558.08 311.19 555.53 326.47 538.27 419.69 535.49 419.69 548.04 326.47 549.9 311.19 558.08 311.19"
        />
        <polygon
          className="animable"
          id="elhqc0ga3l5c"
          style={{
            fill: "rgb(166, 166, 166)",
            transformOrigin: "553.06px 318.83px",
          }}
          points="549.9 311.19 558.08 311.19 555.53 326.47 548.04 326.47 549.9 311.19"
        />
        <polygon
          className="animable"
          id="eldd7pfdovcd"
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "600.985px 365.44px",
          }}
          points="612.28 419.69 609.5 419.69 592.24 326.47 589.69 311.19 597.88 311.19 599.73 326.47 612.28 419.69"
        />
        <polygon
          className="animable"
          id="elexvbofn27a4"
          style={{
            fill: "rgb(166, 166, 166)",
            transformOrigin: "594.71px 318.83px",
          }}
          points="597.88 311.19 599.73 326.47 592.24 326.47 589.69 311.19 597.88 311.19"
        />
        <polygon
          className="animable"
          id="elf8dk8wzdued"
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "652.765px 365.44px",
          }}
          points="664.06 419.69 661.28 419.69 644.02 326.47 641.47 311.19 649.65 311.19 651.51 326.47 664.06 419.69"
        />
        <polygon
          className="animable"
          id="el66t5bj6ruf2"
          style={{
            fill: "rgb(166, 166, 166)",
            transformOrigin: "646.49px 318.83px",
          }}
          points="651.51 326.47 644.02 326.47 641.47 311.19 649.65 311.19 651.51 326.47"
        />
        <polygon
          className="animable"
          id="el71ygpf36q67"
          style={{
            fill: "rgb(0, 185, 143)",
            transformOrigin: "596.405px 265.415px",
          }}
          points="659.65 318.37 533.16 318.37 533.16 305.05 580.51 305.05 596.43 212.46 654.82 212.46 659.65 318.37"
        />
        <polygon
          className="animable"
          id="elkm1rtvzdydm"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "573.665px 258.6px",
          }}
          points="573.12 257.65 572.79 259.55 574.54 258.73 573.12 257.65"
        />
        <polygon
          className="animable"
          id="elu8ff9iko5rs"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "598.61px 231.035px",
          }}
          points="603.68 225.92 601.53 224.28 593.54 237.23 594.37 237.79 603.68 225.92"
        />
        <polygon
          className="animable"
          id="eloxa7kw3d7f"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "562.295px 245.565px",
          }}
          points="552.38 268.04 587.75 268.8 572.2 223.08 536.84 222.33 552.38 268.04"
        />
        <polygon
          className="animable"
          id="el3tulchsj42w"
          style={{
            fill: "rgb(0, 185, 143)",
            transformOrigin: "559.875px 245.51px",
          }}
          points="549.96 267.99 585.33 268.75 569.78 223.03 534.42 222.27 549.96 267.99"
        />
        <g id="el4hldlvjebp7">
          <polygon
            className="animable"
            style={{ opacity: "0.1", transformOrigin: "653.955px 265.415px" }}
            points="659.65 318.37 652.75 318.37 648.26 212.46 654.82 212.46 659.65 318.37"
          />
        </g>
        <g id="elb3u5l32tljk">
          <rect
            className="animable"
            height="1.66"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "601.965px 221.25px",
              transform: "rotate(-142.71deg)",
            }}
            width="8.39"
            x="597.77"
            y="220.42"
          />
        </g>
        <g id="elzc7cuiru3ne">
          <rect
            className="animable"
            height="1.66"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "600.855px 222.71px",
              transform: "rotate(-142.71deg)",
            }}
            width="8.39"
            x="596.66"
            y="221.88"
          />
        </g>
        <path
          className="animable"
          id="elk3epr5xro9n"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "604.485px 197.056px",
          }}
          d="M576.5,228.4c.56,0,3.17.21,7,.49a21.56,21.56,0,0,0,2.82-12.78c-.07-1,2.06,4.91.74,13,7.39.51,17.44,1.21,26.23,1.73.33-3.42.79-6.58.79-6.58a38.3,38.3,0,0,0,1.12,6.7c1.21.09,2.38.14,3.51.21A134.69,134.69,0,0,1,620,216.61a46.94,46.94,0,0,0,3.68,14.86c5.59.27,9.26.35,9,.08-8-10.07-1.57-15.37-3.58-24-2.41-10.35-11.15-12.38-10.54-20,.49-6.24,1.78-17.54-6-20.32a15.22,15.22,0,0,0-16.35-3.91c-12.69,4.2-8.64,23.69-9.67,27.57-1.46,5.54-4.22,7.39-6.5,13.68s.42,10.79.56,15.19S575.1,228.32,576.5,228.4Z"
        />
        <path
          className="animable"
          id="el1g04c3kpv8f"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "625.466px 208.165px",
          }}
          d="M633.06,230.18a21.72,21.72,0,0,1-2.46-5.6,11.48,11.48,0,0,1,.29-5.86,58.84,58.84,0,0,0,1.31-6.13,16.24,16.24,0,0,0-.32-6.46,14.34,14.34,0,0,0-3.11-5.69,37.1,37.1,0,0,0-4.61-4.29,23.73,23.73,0,0,1-4.25-4.31,11.25,11.25,0,0,1-2-5.69,10.49,10.49,0,0,0,1.34,6.09,21.25,21.25,0,0,0,4.07,4.82,46,46,0,0,1,4.27,4.35,13.62,13.62,0,0,1,2.69,5.15,16.08,16.08,0,0,1,.32,5.84c-.21,2-.67,4-1,6a20.5,20.5,0,0,0-.34,3.17,9.15,9.15,0,0,0,.56,3.21A17.91,17.91,0,0,0,633.06,230.18Z"
        />
        <path
          className="animable"
          id="el6b75mu58sl"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "581.61px 198.67px",
          }}
          d="M588.9,170.11a31.24,31.24,0,0,0-2,7.37c-.43,2.52-.74,5.06-1,7.58l-.45,3.77a18.88,18.88,0,0,1-.73,3.59,20.46,20.46,0,0,1-3.7,6.3,28.7,28.7,0,0,0-2.19,3.24,17.46,17.46,0,0,0-1.56,3.67,25.86,25.86,0,0,0-.73,3.87,15.82,15.82,0,0,0,0,3.95c.17,1.32.48,2.56.73,3.78a19.32,19.32,0,0,1,.41,3.7,7.79,7.79,0,0,1-3.36,6.3,7.88,7.88,0,0,0,4.15-6.27,18.81,18.81,0,0,0-.14-3.9c-.17-1.29-.43-2.52-.51-3.74a20,20,0,0,1,.91-7.24,17.53,17.53,0,0,1,1.46-3.32,27.17,27.17,0,0,1,2.11-3c.76-1,1.55-2.06,2.23-3.19a16,16,0,0,0,1.65-3.65,21.35,21.35,0,0,0,.68-3.88c.13-1.28.21-2.55.29-3.82.17-2.54.3-5.07.54-7.59A36.4,36.4,0,0,1,588.9,170.11Z"
        />
        <path
          className="animable"
          id="elxip7mi6pxcj"
          style={{
            fill: "rgb(173, 99, 89)",
            transformOrigin: "521.227px 374.672px",
          }}
          d="M482,395.44c2,1.14,62,13.69,64.59,12.72,1-.36,3.33-9,5.86-19.52.54-2.27,1.09-4.62,1.64-7,3.56-15.51,7-32,7-32l-40.14-8.51L515,373.36l-1.29,7.08s-25.14,5.48-27.87,6.84S480,394.3,482,395.44Z"
        />
        <path
          className="animable"
          id="elpoecide2ywb"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "516.39px 395.253px",
          }}
          d="M551.43,392.66c-2.14,8.62-4,15.19-4.88,15.51-2.58,1-62.64-11.59-64.59-12.73s1.17-6.78,3.88-8.16c1.69-.84,11.9-3.25,19.48-5-6.62,1.58-19,6.07,6.57,7.92C533,391.76,547,392.46,551.43,392.66Z"
        />
        <path
          className="animable"
          id="elpv1rizttnj9"
          style={{
            fill: "rgb(173, 99, 89)",
            transformOrigin: "568.58px 394.253px",
          }}
          d="M536.16,426.15c2.17.61,63.44-2.56,65.7-4.16.86-.6-1.5-25.19-2.14-27.56-2.17-8-12.53-32.15-12.53-32.15l-41,2L563,403.55s-22.92,11.71-25.21,13.72S534,425.54,536.16,426.15Z"
        />
        <path
          className="animable"
          id="elhv22h2ickd"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "568.575px 416.788px",
          }}
          d="M601.86,422c-2.26,1.6-63.52,4.77-65.71,4.16s-.6-6.86,1.68-8.87c1.07-.95,6.61-4,12.22-6.95-7,4-18.19,12.8,51.17-3C601.85,414.38,602.32,421.67,601.86,422Z"
        />
        <path
          className="animable"
          id="elvyl7vssqo0a"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "583.872px 333.255px",
          }}
          d="M631.2,305c-12.21,13.61-53.24,2.86-55.69,8.27-2.16,4.78,25.84,81.44,25.84,81.44l-44.8,4.83s-38.68-84.67-24.85-109.13c7.46-13.21,40.37-7.94,60.22-10.36,6-.73,8.8-13.08,8.8-13.08H636.2S645.16,289.44,631.2,305Z"
        />
        <path
          className="animable"
          id="els2jh0ahq39m"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "591.599px 289.615px",
          }}
          d="M544.15,282.81l37.62,28.79c12.5-.26,39.84,4.06,49.43-6.62,14-15.55,5-38,5-38H600.72s-2.81,12.35-8.8,13.08C578,281.72,557.64,279.64,544.15,282.81Z"
        />
        <path
          className="animable"
          id="elm3vs3y81xkl"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "574.656px 387.594px",
          }}
          d="M554.83,389.53c1.24-.39,12.86-1.68,15.42-2,5.13-.55,21.27-2.06,24.2-2.06a.07.07,0,0,1,0,.14c-2.54.53-12.84,1.74-15.4,2-5.14.53-22.78,2.24-24.2,2.1A.11.11,0,0,1,554.83,389.53Z"
        />
        <path
          className="animable"
          id="eluuxn6p3sw6b"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "601.653px 325.879px",
          }}
          d="M570.08,308.76c2.88-1.43,24.71-.72,40.38-2.19,5.11-.47,10.23-1.56,14.12-4.91a23.35,23.35,0,0,0,7-11.49c1.5-5.35,1.35-10.93,1.09-16.42-.06-1.34-.16-2.69-.24-4,0-.08.13-.09.14,0,1.19,9.83,2.11,20.8-4.28,29.31a20.5,20.5,0,0,1-11.42,7.49c-9.45,2.49-45,1.87-46.24,2.83-1.49,1.14,21.48,71.07,21.94,72.4.08.25-.36.42-.46.17C589.82,376.53,567.57,310,570.08,308.76Z"
        />
        <path
          className="animable"
          id="elgmzjslss44u"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "538.094px 330.784px",
          }}
          d="M530.09,292.76c2.11-5.36,6.93-8.7,14-10,.12,0,.11.15,0,.19-6.18,1.81-10.6,4.29-13,9.51-1.13,2.44-1.72,5.86-2,10.45-1.47,22.9,18.51,74.87,18.91,75.78a.07.07,0,1,1-.12.06C545,374,521.37,314.89,530.09,292.76Z"
        />
        <path
          className="animable"
          id="eldu13qwqojal"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "576.651px 321.78px",
          }}
          d="M513.89,371.3l33.93,7.22s-26.77-79.88-14.2-90.18c3.49-2.86,11.08-3.86,20.11,0,13.48,5.82,29.08,17.69,43.79,22,13.77,4.07,30.12.33,35.75-5.87,11.83-13,2.93-37.6,2.93-37.6l-48.78-1.83s.72.59-1.6,2.65c0,0-28.68-6.5-41.14,1.11C522.21,282.61,513.89,371.3,513.89,371.3Z"
        />
        <path
          className="animable"
          id="elbol91litro"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "621.433px 277.311px",
          }}
          d="M615.13,269.79a.09.09,0,0,1,.17,0,27.1,27.1,0,0,0,.42,5.47,9.4,9.4,0,0,0,2.45,4.54c2.68,2.71,6.51,3.63,10,4.74.19.05.15.38-.06.35-3.89-.6-8-1.59-10.82-4.5a9.48,9.48,0,0,1-2.52-4.9A11.72,11.72,0,0,1,615.13,269.79Z"
        />
        <path
          className="animable"
          id="el9z4m8ot69w6"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "540.498px 332.006px",
          }}
          d="M534.46,286.81c5.22-3.27,13.37-.79,17.28.71.08,0,0,.16,0,.13-3.59-1.29-12.53-3.24-17.31.14-11,7.82,3.74,61.3,13.43,90.73.15.46-.22.34-.42-.11-1.6-3.49-14.09-40.68-17.34-65.28C529.56,309.35,526.94,291.53,534.46,286.81Z"
        />
        <path
          className="animable"
          id="elu2qnf7g9tz"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "531.103px 365.52px",
          }}
          d="M517.76,362.28c1,0,9.82,1.92,11.75,2.35,3.88.87,12.85,3.2,15,4,.06,0,0,.13,0,.13-2-.19-6.69-1.22-8.62-1.67-3.87-.9-17.13-4.08-18.1-4.6C517.61,362.45,517.66,362.29,517.76,362.28Z"
        />
        <path
          className="animable"
          id="el3oggiufzrsv"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "585.489px 287.575px",
          }}
          d="M536.12,285.42a19.29,19.29,0,0,1,11.59-1.75,40.6,40.6,0,0,1,11.83,3.7C567.48,291,575,295.43,583,299s16.34,6.4,25,6.67c7.45.23,16.87-1.08,21.65-7.78,7.37-10.31,3.08-28.1,3-29.25,0-.09.12-.08.14,0,5.72,21.87-1.64,30.35-6.61,33.92-3.94,2.84-9.61,3.55-13.35,3.87-8.66.73-17.35-1.39-25.37-4.59-8.23-3.27-16-7.69-23.83-11.72-7.56-3.86-16-7.85-24.61-5.64a22.05,22.05,0,0,0-2.87,1S536.08,285.45,536.12,285.42Z"
        />
        <path
          className="animable"
          id="eli4twbm33gh"
          style={{
            fill: "rgb(173, 99, 89)",
            transformOrigin: "569.505px 235.884px",
          }}
          d="M603.62,221.14c-4.06,10.1-20.23,42.75-30.85,45.06-7,1.51-35.13-1.22-40-7.88-2.11-2.9,1.46-23.14,5.22-22.34s26.33,3.79,29.1,3,23.55-24.73,31.32-30.67C611.81,198.05,605.82,215.7,603.62,221.14Z"
        />
        <path
          className="animable"
          id="elratah522ln"
          style={{
            fill: "rgb(166, 166, 166)",
            transformOrigin: "577.63px 235.116px",
          }}
          d="M546.53,234.53l-.6,30.41s22.31,4.07,31.86.38c11.58-4.48,27.44-41.43,29.58-47.49,3.51-9.94,2.22-15.84-3.19-14.19-2.11.62-4.84,2.4-8.16,5.54s-23.32,24.4-29.68,28.49C562.79,240,546.53,234.53,546.53,234.53Z"
        />
        <path
          className="animable"
          id="ellb2kezvpuy"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "551.51px 250.133px",
          }}
          d="M551.58,263.65c.22-4.49.47-22.9.25-26.89,0-.27-.2-.33-.22,0-1,13.44-.21,22.5-.21,26.91C551.4,263.75,551.58,263.76,551.58,263.65Z"
        />
        <path
          className="animable"
          id="eln7e0assqpfm"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "582.356px 235.114px",
          }}
          d="M555.38,266.24c7.26.76,16.94,1.19,22.41-.92,11.58-4.48,27.44-41.43,29.58-47.48,3.51-10,2.23-15.85-3.19-14.2l-.51.17Z"
        />
        <path
          className="animable"
          id="el20qg5z0keyc"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "609.97px 235.871px",
          }}
          d="M637.19,270.35l-54.44-4.93,6-22.1a17.87,17.87,0,0,1-2.57-14.91c1.36-5,8.48-14.63,12.46-19.42,9.71-11.66,17.27-7.2,20-4.2C628.84,216.25,637.19,270.35,637.19,270.35Z"
        />
        <path
          className="animable"
          id="el1e1yoyihfly"
          style={{
            fill: "rgb(166, 166, 166)",
            transformOrigin: "611.995px 240.225px",
          }}
          d="M615,202s-6.12,17.25-8.31,20.65-8.63,9.48-8.63,9.48-.75-8.78,0-13.79,4.35-13.18,4.35-13.18a10.7,10.7,0,0,0-3,2.37c-4.83,4.93-12.59,15.64-13.86,22.28a17.76,17.76,0,0,0,2.6,13.41l-7.33,23.39,9.64,2.15,4.67-5.38,3.45,7,44.59,8.07-5.41-17.12s-10.5-45.37-14.81-51.55C617.94,202.67,615,202,615,202Z"
        />
        <path
          className="animable"
          id="el2s0nm5nu7z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "596.676px 242.661px",
          }}
          d="M604,242.32a50.11,50.11,0,0,0-7.35-.13c-1.22.09-2.42.23-3.63.4-.6.08-1.2.15-1.81.21a8.05,8.05,0,0,1-1.9,0c-.05,0-.07.07,0,.09a14.84,14.84,0,0,0,1.77.29,12.78,12.78,0,0,0,1.75,0c1.23-.07,2.46-.21,3.7-.29,2.49-.18,5-.36,7.47-.36C604.11,242.52,604.12,242.32,604,242.32Z"
        />
        <path
          className="animable"
          id="elmhpj2uy0j4"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "603.597px 244.715px",
          }}
          d="M609.56,245.52a56.29,56.29,0,0,0-5.91-1.37c-1-.17-2-.27-3-.36l-1.45-.1c-.53,0-1.06,0-1.59,0-.06,0-.07.08,0,.09.5.05,1,.18,1.49.26l1.5.23,3,.47c2,.29,4,.6,6,1C609.64,245.71,609.66,245.55,609.56,245.52Z"
        />
        <path
          className="animable"
          id="elxurvewtyiv"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "607.13px 220.23px",
          }}
          d="M614.67,204.71c.58,4,1.23,7.91,1.9,11.85l.2-.32c-2.32.61-4.64,1.27-7,1.91l-.39.11.17.37c.69,1.53,1.37,3.06,2.09,4.57l.09-.42c-2.45,2.14-4.94,4.24-7.37,6.42s-4.86,4.33-7.25,6.55c2.57-2,5.09-4.07,7.6-6.15s5-4.18,7.49-6.27l.2-.18-.11-.25c-.68-1.53-1.4-3-2.1-4.56l-.23.48c2.31-.68,4.63-1.33,6.93-2l.26-.08-.05-.25C616.35,212.54,615.55,208.62,614.67,204.71Z"
        />
        <path
          className="animable"
          id="ellc7ybozcwn"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "597.845px 220.85px",
          }}
          d="M601.8,205.9c-1.29,1.34-7.19,9-7.19,9l-.25.29.33.2,2.41,1.5-.07-.54c-1,1-2,2-3,3l-.14.14,0,.18c.5,2.69.95,5.39,1.5,8.08s1.07,5.37,1.68,8.05c-.33-2.72-.73-5.44-1.15-8.14s-.89-5.41-1.32-8.12l-.1.32c1-1,2-2,2.95-3l.31-.32-.38-.22L595,214.8l.07.49C596.32,213.88,600.65,207.37,601.8,205.9Z"
        />
        <path
          className="animable"
          id="elnuepx6xua9"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "596.099px 248.5px",
          }}
          d="M597.15,235.75c-.34,1.31-.7,2.61-1,3.93s-.62,2.63-.91,3.94v0c-.09,2.93-.12,5.87-.17,8.81s0,5.88,0,8.82q.25-4.41.4-8.81c.07-2.94.17-5.88.2-8.81v0c.28-1.32.54-2.65.78-4S596.93,237.08,597.15,235.75Z"
        />
        <path
          className="animable"
          id="elw9tlu8tdgpj"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "598.88px 239.254px",
          }}
          d="M598.69,238.3a1,1,0,0,1,.77.18,1,1,0,0,1,.37.77,1,1,0,0,1-.37.77,1,1,0,0,1-.77.19,1,1,0,0,1-.76-1A1,1,0,0,1,598.69,238.3Zm-.5,1.46a.61.61,0,0,0,.5.08.63.63,0,0,0,0-1.17.6.6,0,0,0-.76.58A.62.62,0,0,0,598.19,239.76Z"
        />
        <path
          className="animable"
          id="elei99tzke0af"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "597.728px 247.755px",
          }}
          d="M597.55,246.8a1,1,0,0,1,.77.19,1,1,0,0,1,0,1.53,1,1,0,0,1-.77.19,1,1,0,0,1-.77-1A1,1,0,0,1,597.55,246.8Zm-.51,1.46a.63.63,0,0,0,.51.08.59.59,0,0,0,.39-.59.6.6,0,0,0-.39-.58.63.63,0,0,0-.51.08.62.62,0,0,0,0,1Z"
        />
        <path
          className="animable"
          id="eleah1sv38ugh"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "597.331px 255.536px",
          }}
          d="M597.15,254.58a1,1,0,0,1,.77.19,1,1,0,0,1,0,1.54,1,1,0,0,1-.77.18,1,1,0,0,1-.77-1A1,1,0,0,1,597.15,254.58Zm-.51,1.46a.6.6,0,0,0,.51.08.62.62,0,0,0,0-1.16.63.63,0,0,0-.51.07.69.69,0,0,0-.26.51A.62.62,0,0,0,596.64,256Z"
        />
        <path
          className="animable"
          id="el4ngasqmovhw"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "603.2px 219.345px",
          }}
          d="M605.05,223.13s4-4.43.74-6.89-6.46,2.54-6.46,2.54Z"
        />
        <path
          className="animable"
          id="elgfqo02pajoa"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "588.965px 239.06px",
          }}
          d="M574.11,251.9h0l-1,5.74-.34,1.89,1.75-.81,5.28-2.47h0l25.36-33.31-5.71-4.35L574.11,251.9Z"
        />
        <path
          className="animable"
          id="elwp8c5af641q"
          style={{
            fill: "rgb(173, 99, 89)",
            transformOrigin: "628.101px 240.635px",
          }}
          d="M628.57,214.45c16,20.05,33.43,53.27,24.71,59.6-8,5.77-35.27-1.88-52.24-9.76-3.23-1.5,12-30,15.28-28a97.61,97.61,0,0,0,10.7,5.64c.94.32-3-11.36-7.95-25.53C613.6,200.59,619.41,203,628.57,214.45Z"
        />
        <path
          className="animable"
          id="elwzvlpyiojkd"
          style={{
            fill: "rgb(173, 99, 89)",
            transformOrigin: "596.218px 246.548px",
          }}
          d="M574.18,231.48c-.23,3.41,8.21,3.26,8.21,3.26a6.26,6.26,0,0,0-2.77,3.26c-.79,2.47,2.74,4.79,2.74,4.79A7.79,7.79,0,0,0,580,246.7c-.52,2.44,2.71,5.29,2.71,5.29a6.79,6.79,0,0,0,.08,4.75c1.75,4,8.46,4.5,12.55,5.62a89.68,89.68,0,0,1,13.33,5.17l9.59-30.1s-17.31-11.79-22.35-11.86C591.65,225.51,574.53,226.28,574.18,231.48Z"
        />
        <path
          className="animable"
          id="elkctzbf8ol9s"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "589.403px 234.304px",
          }}
          d="M582.47,234.64c4.53-1,9.29-.95,13.89-.83.1,0,.09.16,0,.16-4.57-.17-9.29.88-13.86.89A.11.11,0,0,1,582.47,234.64Z"
        />
        <path
          className="animable"
          id="el2nnwpsqnrtd"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "589.089px 243.08px",
          }}
          d="M582.51,242.45a12.38,12.38,0,0,1,3.16,0c1.12.09,2.23.19,3.35.31,2.23.24,4.46.54,6.67.9.1,0,.1.17,0,.15-2.23-.23-4.45-.44-6.69-.58l-3.35-.19a14.44,14.44,0,0,1-3.15-.3A.16.16,0,0,1,582.51,242.45Z"
        />
        <path
          className="animable"
          id="eliggogrxfhyf"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "588.808px 252.655px",
          }}
          d="M582.79,252a8.57,8.57,0,0,1,2.85.17c1,.14,2,.26,3.05.38,2,.24,4.06.48,6.1.65.1,0,.09.17,0,.16-2.07-.16-4.14-.29-6.22-.47l-3-.29a7.85,7.85,0,0,1-2.73-.49A.06.06,0,0,1,582.79,252Z"
        />
        <path
          className="animable"
          id="el1g00m3bxo7a"
          style={{
            fill: "rgb(166, 166, 166)",
            transformOrigin: "633.273px 240.762px",
          }}
          d="M620.62,205.56c12,8.26,41.51,54.76,35,66.82S610,268.81,610,268.81l5.23-33.36s10.18,6.43,10.56,5.92-4.95-16.14-7.13-22.5S614.25,201.17,620.62,205.56Z"
        />
        <path
          className="animable"
          id="eldnlp9dt8sm5"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "617.385px 253.834px",
          }}
          d="M615.13,267.16c1-4.39,4.24-22.51,4.69-26.47,0-.27-.14-.36-.21-.08-3.2,13.09-3.93,22.15-4.66,26.51C614.94,267.23,615.1,267.28,615.13,267.16Z"
        />
        <path
          className="animable"
          id="elor5cdzb6le"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "627.38px 243.092px",
          }}
          d="M615.45,235.49a23.92,23.92,0,0,1,3.29,1.72c1,.55,1.93,1.09,2.88,1.65,2.07,1.21,4.11,2.47,6.14,3.75s4,2.56,6,3.89,3.91,2.76,5.91,4.09c.09.06,0,.19-.11.13-2-1.29-4.14-2.45-6.2-3.69l-6.06-3.66-6.06-3.64-2.95-1.81a28.2,28.2,0,0,1-3.12-2A.24.24,0,0,1,615.45,235.49Z"
        />
        <path
          className="animable"
          id="elv12i29juej"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "622.879px 232.575px",
          }}
          d="M619.46,226c.6.85,1.19,1.71,1.75,2.6l.3.5c-.15-.45-.29-.9-.43-1.34a44.58,44.58,0,0,1-1.42-4.75c0-.07.09-.1.12,0a46.11,46.11,0,0,1,1.86,4.82c.58,1.58,1.17,3.15,1.72,4.74s1.11,3.18,1.63,4.78a33.21,33.21,0,0,1,1.36,4.77.09.09,0,0,1-.16.05,34.86,34.86,0,0,1-1.93-4.8c-.56-1.58-1.09-3.18-1.63-4.77-.23-.67-.44-1.34-.66-2l-.3-.46c-.28-.43-.54-.86-.79-1.31-.52-.9-1-1.83-1.47-2.76C619.4,226,619.44,226,619.46,226Z"
        />
        <path
          className="animable"
          id="ellb6nm1cq8k"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "625.364px 272.456px",
          }}
          d="M609.94,268.07c0-.23.15-.27.18,0s0,.37,0,.5c1.34.44,6.23,2.21,7.43,2.63,2.5.88,5,1.68,7.6,2.38s5.15,1.33,7.76,1.88,5.22,1.1,7.85,1.41a.08.08,0,1,1,0,.16c-2.68-.27-5.36-.49-8-.93s-5.2-1-7.76-1.68-5.19-1.5-7.73-2.41c-1.26-.46-2.52-.95-3.77-1.47A19.59,19.59,0,0,1,610,268.9a.28.28,0,0,1-.11-.26C609.89,268.45,609.91,268.26,609.94,268.07Z"
        />
        <path
          className="animable"
          id="ell6ojvq6e4yl"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "567.132px 223.108px",
          }}
          d="M566,223a3.08,3.08,0,0,0,1.47,1.88c.34.19.44-.25.11-.43a2.34,2.34,0,0,1-1-1.18c0-.08-.05-.17-.07-.26a1.69,1.69,0,0,1,0-.86.62.62,0,0,1,.21-.31l0,0,0,0h.07a.43.43,0,0,1,.25,0,1,1,0,0,1,.4.27,1.92,1.92,0,0,1,.34.48,2.2,2.2,0,0,1,.15.26l0,.07a.36.36,0,0,1,0,.09s0,0,0,.06h.51a4,4,0,0,0-.46-.89,2,2,0,0,0-1.34-.89.78.78,0,0,0-.81.71A2.09,2.09,0,0,0,566,223Z"
        />
        <path
          className="animable"
          id="elit1f1y26v4s"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "564.401px 222.998px",
          }}
          d="M563.26,222.89a3.1,3.1,0,0,0,1.48,1.88c.33.19.43-.25.1-.43a2.32,2.32,0,0,1-1-1.18,2.41,2.41,0,0,1-.08-.25,1.73,1.73,0,0,1,0-.87.54.54,0,0,1,.2-.31l0,0h.11a.43.43,0,0,1,.25,0,1.05,1.05,0,0,1,.4.27,2.11,2.11,0,0,1,.34.48,1.73,1.73,0,0,1,.15.27l0,.06a.36.36,0,0,1,0,.09s0,0,0,.06h.5a3.54,3.54,0,0,0-.46-.88,1.93,1.93,0,0,0-1.34-.9.78.78,0,0,0-.81.71A2.09,2.09,0,0,0,563.26,222.89Z"
        />
        <path
          className="animable"
          id="el676xhuxnsbn"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "561.598px 222.946px",
          }}
          d="M560.49,222.84a3.19,3.19,0,0,0,1.48,1.88c.33.18.43-.26.1-.43a2.39,2.39,0,0,1-1-1.19,2.41,2.41,0,0,1-.08-.25,1.73,1.73,0,0,1,0-.87.49.49,0,0,1,.2-.3l0,0,0,0h.07a.4.4,0,0,1,.24,0,1.05,1.05,0,0,1,.4.27,2.17,2.17,0,0,1,.35.48q.08.12.15.27l0,.06a.36.36,0,0,1,0,.09.14.14,0,0,1,0,.06h.5a3.54,3.54,0,0,0-.46-.88,2,2,0,0,0-1.34-.9.77.77,0,0,0-.8.71A2,2,0,0,0,560.49,222.84Z"
        />
        <path
          className="animable"
          id="elcg8zlvkjmsk"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "558.846px 222.886px",
          }}
          d="M557.72,222.78a3.19,3.19,0,0,0,1.48,1.88c.33.18.43-.26.1-.43a2.39,2.39,0,0,1-1-1.19,1.17,1.17,0,0,1-.07-.25,1.63,1.63,0,0,1,0-.87.5.5,0,0,1,.21-.3l0,0,0,0h.07a.44.44,0,0,1,.25,0,1.13,1.13,0,0,1,.4.27,2.48,2.48,0,0,1,.34.48,2.34,2.34,0,0,1,.15.27l0,.06a.36.36,0,0,1,0,.09.14.14,0,0,1,0,.06h.5a3.54,3.54,0,0,0-.46-.88,2,2,0,0,0-1.34-.9.77.77,0,0,0-.8.71A2,2,0,0,0,557.72,222.78Z"
        />
        <path
          className="animable"
          id="elrwt0hr3ufl"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "556.132px 222.831px",
          }}
          d="M555,222.72a3.14,3.14,0,0,0,1.47,1.88c.34.18.43-.26.11-.43a2.33,2.33,0,0,1-1-1.19l-.07-.25a1.73,1.73,0,0,1,0-.87.54.54,0,0,1,.21-.3l0,0,0,0h.07a.44.44,0,0,1,.25,0,1.13,1.13,0,0,1,.4.27,2.11,2.11,0,0,1,.34.48c.06.09.1.18.15.27l0,.06a.36.36,0,0,1,0,.09s0,0,0,.06h.51a3.91,3.91,0,0,0-.46-.88,1.91,1.91,0,0,0-1.34-.89.78.78,0,0,0-.81.7A2.13,2.13,0,0,0,555,222.72Z"
        />
        <path
          className="animable"
          id="elk284pl7qu6"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "553.376px 222.768px",
          }}
          d="M552.19,222.66a3.11,3.11,0,0,0,1.47,1.88c.34.19.44-.25.11-.43a2.31,2.31,0,0,1-1-1.19,2.41,2.41,0,0,1-.08-.25,1.62,1.62,0,0,1,0-.87.52.52,0,0,1,.2-.3s0,0,0,0l0,0H553a.37.37,0,0,1,.25,0,.87.87,0,0,1,.4.27,1.87,1.87,0,0,1,.34.47c.06.09.1.18.15.27l0,.06a.2.2,0,0,1,.05.09s0,0,0,.06h.5a3.54,3.54,0,0,0-.46-.88,1.91,1.91,0,0,0-1.34-.89.78.78,0,0,0-.81.7A2.13,2.13,0,0,0,552.19,222.66Z"
        />
        <path
          className="animable"
          id="elo5pl23h0ede"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "550.524px 222.708px",
          }}
          d="M549.42,222.6a3.16,3.16,0,0,0,1.48,1.88c.33.19.43-.25.1-.43a2.31,2.31,0,0,1-1-1.19,2.41,2.41,0,0,1-.08-.25,1.69,1.69,0,0,1,0-.86.54.54,0,0,1,.2-.31l0,0,0,0h.07a.34.34,0,0,1,.24,0,.87.87,0,0,1,.4.27,2,2,0,0,1,.35.48l.15.26,0,.06a.36.36,0,0,1,0,.09.14.14,0,0,1,0,.06h.5a3.72,3.72,0,0,0-.46-.88,1.91,1.91,0,0,0-1.34-.89.78.78,0,0,0-.81.7A2.13,2.13,0,0,0,549.42,222.6Z"
        />
        <path
          className="animable"
          id="elqcc5ja4min"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "547.776px 222.648px",
          }}
          d="M546.65,222.54a3.16,3.16,0,0,0,1.48,1.88c.33.19.43-.25.1-.43a2.35,2.35,0,0,1-1-1.19,1.17,1.17,0,0,1-.07-.25,1.59,1.59,0,0,1,0-.86.56.56,0,0,1,.21-.31l0,0,0,0h.07a.44.44,0,0,1,.25,0,.92.92,0,0,1,.4.27,2,2,0,0,1,.34.48,2.2,2.2,0,0,1,.15.26l0,.06a.36.36,0,0,1,0,.09.14.14,0,0,1,0,.06h.5a3.72,3.72,0,0,0-.46-.88,1.91,1.91,0,0,0-1.34-.89.77.77,0,0,0-.8.7A2,2,0,0,0,546.65,222.54Z"
        />
        <path
          className="animable"
          id="el3v1rglnatyy"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "545.022px 222.588px",
          }}
          d="M543.89,222.48a3.11,3.11,0,0,0,1.47,1.88c.33.19.43-.25.11-.43a2.33,2.33,0,0,1-1-1.19l-.07-.25a1.59,1.59,0,0,1,0-.86.56.56,0,0,1,.21-.31l0,0,0,0h.07a.44.44,0,0,1,.25,0,.92.92,0,0,1,.4.27,2,2,0,0,1,.34.48,2.2,2.2,0,0,1,.15.26l0,.06a.36.36,0,0,1,0,.09s0,0,0,.06h.51a4.13,4.13,0,0,0-.46-.88,1.93,1.93,0,0,0-1.34-.89.78.78,0,0,0-.81.71A2.09,2.09,0,0,0,543.89,222.48Z"
        />
        <path
          className="animable"
          id="el2fo7ox1wm0v"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "542.261px 222.528px",
          }}
          d="M541.12,222.42a3.11,3.11,0,0,0,1.47,1.88c.34.19.44-.25.11-.43a2.32,2.32,0,0,1-1-1.18c0-.09-.06-.18-.08-.26a1.58,1.58,0,0,1,0-.86.54.54,0,0,1,.2-.31l0,0,.05,0h.06a.54.54,0,0,1,.25,0,1,1,0,0,1,.4.27,1.92,1.92,0,0,1,.34.48,2.2,2.2,0,0,1,.15.26l0,.06,0,.09s0,0,0,.07h.5a4,4,0,0,0-.46-.89,1.91,1.91,0,0,0-1.34-.89.78.78,0,0,0-.81.71A2.09,2.09,0,0,0,541.12,222.42Z"
        />
        <path
          className="animable"
          id="elnn356o3v25"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "539.454px 222.468px",
          }}
          d="M538.35,222.36a3.13,3.13,0,0,0,1.48,1.88c.33.19.43-.25.1-.43a2.32,2.32,0,0,1-1-1.18,2.58,2.58,0,0,1-.08-.26,1.69,1.69,0,0,1,0-.86.54.54,0,0,1,.2-.31l0,0,0,0h.07a.51.51,0,0,1,.24,0,1,1,0,0,1,.4.27,2.26,2.26,0,0,1,.35.48l.15.26,0,.06a.3.3,0,0,1,0,.1s0,0,0,.06h.5a3.6,3.6,0,0,0-.46-.89,1.91,1.91,0,0,0-1.34-.89.79.79,0,0,0-.81.71A2.09,2.09,0,0,0,538.35,222.36Z"
        />
        <path
          className="animable"
          id="el8tj2g51yy6"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "536.697px 222.408px",
          }}
          d="M535.58,222.3a3.16,3.16,0,0,0,1.48,1.88c.33.19.43-.25.1-.43a2.37,2.37,0,0,1-1-1.18,1.11,1.11,0,0,1-.07-.26,1.59,1.59,0,0,1,0-.86.6.6,0,0,1,.2-.31l0,0,0,0h.07a.44.44,0,0,1,.25,0,1,1,0,0,1,.4.27,4.78,4.78,0,0,1,.49.74l0,.06a.69.69,0,0,1,0,.1.14.14,0,0,1,0,.06h.5a3.6,3.6,0,0,0-.46-.89,1.91,1.91,0,0,0-1.34-.89.77.77,0,0,0-.8.71A2,2,0,0,0,535.58,222.3Z"
        />
        <path
          className="animable"
          id="elh4r8pudm12h"
          style={{
            fill: "rgb(173, 99, 89)",
            transformOrigin: "543.533px 250.972px",
          }}
          d="M536.69,232.62c-1.67,3.91-6.07,8.85-6.32,12a3.62,3.62,0,0,0,2.16,3.75s-3.06,1.68-2.82,4.58c.12,1.49,2.61,2.6,2.61,2.6a4.3,4.3,0,0,0-2,4c.3,2.05,2.75,2.85,2.75,2.85s-1.65,2.47-.68,4.45c2,4,19.66,3.32,22.14-3.3,1.15-3.09-3.16-2.68-3.16-2.68s6.06-2.08,6-5.74-5.63-2.78-5.63-2.78,5.86-2.07,5.43-5.85c-.46-3.94-5.88-2.12-5.88-2.12s3.83-2.82,2.83-5.64c-1.64-4.65-8.86,1.57-12.78.8l-2.4-6.33Z"
        />
        <path
          className="animable"
          id="el2dshvenu2ou"
          style={{
            fill: "rgb(173, 99, 89)",
            transformOrigin: "534.757px 231.602px",
          }}
          d="M533.36,238.33c1.26-3.84-3.61-8.33-2.93-12.17.91-5.2,6.91-.38,8.5,7.06l.22,6Z"
        />
        <path
          className="animable"
          id="el0pl2a6q5esu"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "542.542px 261.918px",
          }}
          d="M533.42,262.6c-.06,0-.08.08,0,.09a30.71,30.71,0,0,0,18.19-1.81c.18-.08.12-.41-.1-.36A62.9,62.9,0,0,1,533.42,262.6Z"
        />
        <path
          className="animable"
          id="elkynd6xqldo9"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "542.153px 254.206px",
          }}
          d="M532.24,255.59c-.07,0-.08.11,0,.12a28.75,28.75,0,0,0,19.71-3.2c.2-.12.26-.44,0-.32C547.8,254.3,538,255.85,532.24,255.59Z"
        />
        <path
          className="animable"
          id="el78s5pxupryn"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "542.252px 246.489px",
          }}
          d="M551.63,244c-5.87,3.26-12.2,4.3-18.85,4.44-.09,0-.08.12,0,.14,3.27.82,7.5.29,10.76-.4a17.76,17.76,0,0,0,8.21-4C551.84,244.12,551.76,243.92,551.63,244Z"
        />
        <path
          className="animable"
          id="eljo3ohl4pf3i"
          style={{
            fill: "rgb(173, 99, 89)",
            transformOrigin: "607.155px 198.28px",
          }}
          d="M613.81,202.64c-.15,1-4.28,7.58-8.7,7.71-1.44,0-2-7.81-2-7.81l-.18-.57-2.43-8,9.07-6.84,1.32-.92s.52,2.23,1.14,5c0,.13.06.25.09.39s.08.31.11.45c.09.42.19.84.28,1.26s.14.64.2,1,.13.67.2,1A53.8,53.8,0,0,1,613.81,202.64Z"
        />
        <path
          className="animable"
          id="el1r4574id39l"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "606.235px 194.09px",
          }}
          d="M612,191.25a16.68,16.68,0,0,1-9.1,10.72l-2.43-8,9.07-6.84,1.32-.92S611.41,188.47,612,191.25Z"
        />
        <path
          className="animable"
          id="ela41z3kzjzp7"
          style={{
            fill: "rgb(173, 99, 89)",
            transformOrigin: "600.051px 181.734px",
          }}
          d="M587.32,184.88c2.49,14.42,11.41,14.56,14.52,14,2.82-.49,12.37-2.52,11.39-17.12s-8.48-18-15-17.23S584.84,170.45,587.32,184.88Z"
        />
        <path
          className="animable"
          id="elb6dmz085xwi"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "589.353px 180.829px",
          }}
          d="M588.76,181.71c.33-.1.62-.24.94-.37a1.7,1.7,0,0,0,.89-.56.53.53,0,0,0-.11-.63,1.3,1.3,0,0,0-1.31-.08,1.92,1.92,0,0,0-1.06.86A.56.56,0,0,0,588.76,181.71Z"
        />
        <path
          className="animable"
          id="elzswrmn0mhg"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "597.422px 178.317px",
          }}
          d="M598.25,179a8.44,8.44,0,0,1-1,0,1.63,1.63,0,0,1-1-.23.52.52,0,0,1-.11-.63,1.28,1.28,0,0,1,1.2-.51,1.89,1.89,0,0,1,1.29.46A.55.55,0,0,1,598.25,179Z"
        />
        <path
          className="animable"
          id="elftlkr0smjc"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "597.712px 184.111px",
          }}
          d="M597,182.92s.09,0,.09.08c.12,1,.41,2.1,1.35,2.3,0,0,0,0,0,0C597.28,185.36,596.9,183.88,597,182.92Z"
        />
        <path
          className="animable"
          id="ellgai3jjtzi"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "598.082px 183.329px",
          }}
          d="M597.68,181.76c1.57-.35,2.16,2.81.71,3.14S596.37,182.06,597.68,181.76Z"
        />
        <path
          className="animable"
          id="elslph6i48qep"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "599.232px 182.157px",
          }}
          d="M598.33,181.81c.31.13.64.39,1,.36s.62-.42.81-.78c0,0,.06,0,.07,0a1.19,1.19,0,0,1-.63,1.49c-.58.19-1.1-.27-1.37-.85C598.14,182,598.21,181.76,598.33,181.81Z"
        />
        <path
          className="animable"
          id="eluqlx2hexd0q"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "591.163px 185.18px",
          }}
          d="M591.28,183.79s-.06.06,0,.1c.22,1,.31,2.13-.51,2.62,0,0,0,.07,0,.06C591.79,186.2,591.65,184.68,591.28,183.79Z"
        />
        <path
          className="animable"
          id="el1m0dez9itof"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "590.353px 184.536px",
          }}
          d="M590.21,182.94c-1.6.19-1.1,3.37.38,3.19S591.55,182.78,590.21,182.94Z"
        />
        <path
          className="animable"
          id="elagmu9bdyu9c"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "588.885px 183.91px",
          }}
          d="M589.58,183.25c-.22.21-.43.56-.72.62s-.66-.22-.93-.52c0,0,0,0,0,0,.07.61.37,1.21,1,1.24s.86-.56.91-1.19C589.78,183.33,589.67,183.17,589.58,183.25Z"
        />
        <path
          className="animable"
          id="elwjc4i86aap"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "597.681px 191.264px",
          }}
          d="M598.5,190.7c-.18.29-.34.65-.68.77a2.91,2.91,0,0,1-1.1,0,0,0,0,0,0,0,.06,1.33,1.33,0,0,0,1.35.23,1.06,1.06,0,0,0,.57-1C598.61,190.67,598.53,190.66,598.5,190.7Z"
        />
        <path
          className="animable"
          id="elh02uuzpn4hq"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "595.067px 184.301px",
          }}
          d="M593.77,187.88s.1,1.71.22,2.41a7.7,7.7,0,0,0,3.65-1c.73-.41.49-.57,0-.41a13.94,13.94,0,0,1-3.14.78c-.08-.19-.1-2.56-.21-2.55a6.16,6.16,0,0,0-1.51.63c-.21-3.12.09-6.25-.16-9.36a.1.1,0,0,0-.19,0,51,51,0,0,0-.26,10.1C592.19,188.81,593.52,188,593.77,187.88Z"
        />
        <path
          className="animable"
          id="elliujtn292"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "599.965px 172.298px",
          }}
          d="M613,181.26c-2.28.86-4.23-3.89-4.23-3.89s-4.75,1.39-8.28-5a11,11,0,0,0,3.73,5S595.63,179,590.08,173c0,0,2.44,3.16,4.12,4.05a10.23,10.23,0,0,1-6.33-2.33s-.29,4.47-1.1,5.91c0,0-3.89-14.74,10.13-17.11,0,0,8.66-1.89,13.66,4S613,181.26,613,181.26Z"
        />
        <path
          className="animable"
          id="elhs6y42ek44u"
          style={{
            fill: "rgb(0, 185, 143)",
            transformOrigin: "593.035px 184.326px",
          }}
          d="M594.38,184.78l.3-.53c-.75-.48-2.41-1-3.29.32l.49.35C592.67,183.71,594.31,184.73,594.38,184.78Z"
        />
        <path
          className="animable"
          id="elemgqukxf0np"
          style={{
            fill: "rgb(0, 185, 143)",
            transformOrigin: "609.145px 181.49px",
          }}
          d="M615.06,182.8l.5-.37c-.18-.23-1.7-2.28-3.1-2.29s-9.38,2-9.73,2.1l.16.6c2.31-.58,8.55-2.09,9.56-2.08S614.64,182.23,615.06,182.8Z"
        />
        <path
          className="animable"
          id="el3ztt8py12fu"
          style={{
            fill: "rgb(0, 185, 143)",
            transformOrigin: "598.83px 183.483px",
          }}
          d="M595.4,187c-.74-.49-1.72-2.47-1-3.54,1.27-2,8.41-3.75,8.71-3.82l.4-.1V180c0,.18.09,4.38-1.08,5.8a4.81,4.81,0,0,1-2.27,1.24C598.42,187.51,596.32,187.61,595.4,187Zm-.48-3.18c-.44.68.32,2.29.84,2.63,1.08.7,5.12.12,6.13-1.12.76-.92.93-3.58.93-5C600.59,181,595.79,182.46,594.92,183.83Z"
        />
        <path
          className="animable"
          id="el27f3s3nwbr"
          style={{
            fill: "rgb(0, 185, 143)",
            transformOrigin: "588.416px 185.325px",
          }}
          d="M589.1,188.29a2.54,2.54,0,0,1-2.18-.64c-.9-1.05-1.88-4.76-1.92-4.92l-.1-.38.4,0c.51,0,5-.34,6.12,1.26a3.65,3.65,0,0,1,.17,3.41,2.75,2.75,0,0,1-1.64,1.13A4.73,4.73,0,0,1,589.1,188.29Zm-1.68-1.07a1.92,1.92,0,0,0,1.62.41,2.66,2.66,0,0,0,2-1,3,3,0,0,0-.14-2.72c-.67-1-3.64-1.07-5.14-1A16.67,16.67,0,0,0,587.42,187.22Z"
        />
        <path
          className="animable"
          id="el557hytt51en"
          style={{
            fill: "rgb(173, 99, 89)",
            transformOrigin: "613.966px 183.427px",
          }}
          d="M611.13,183.28s1.92-5.23,4.22-4.65,1.66,7.59-.47,9.08a2.46,2.46,0,0,1-3.54-.44Z"
        />
        <path
          className="animable"
          id="el4vx6cuqyemh"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "613.799px 183.877px",
          }}
          d="M615.12,180.63s0,0,0,.06A6.23,6.23,0,0,0,613,185.3a1.37,1.37,0,0,1,1.89-.88c.05,0,0,.1,0,.1a1.51,1.51,0,0,0-1.48.94A7.23,7.23,0,0,0,613,187c0,.17-.33.16-.32,0v0C612.05,184.81,612.91,181.44,615.12,180.63Z"
        />
        <path
          className="animable"
          id="el9zpourgdtp"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "608.305px 207.844px",
          }}
          d="M603,202.33l2.31,6.51,8.3-8.9,2,3.17s-8.24,13.2-8.26,12.62L605,210.1l-4,3.68.72-9.63Z"
        />
        <path
          className="animable"
          id="ele1t9d668db"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "608.269px 209.695px",
          }}
          d="M601.09,209c.17-1.59.29-3.19.54-4.76,0-.06.1-.08.11,0,.25,1.54-.44,7.61-.49,9.06h0c.16-.16,3.67-3.23,3.7-3.18.54.9,2.3,5,2.42,5.37,1.32-2,6.79-10.49,8.33-12.36,0-.05.13,0,.09.06-1.17,2.11-8.28,13.12-8.38,13.09a64.24,64.24,0,0,1-2.51-5.95,42.63,42.63,0,0,1-4.16,3.92A48.15,48.15,0,0,1,601.09,209Z"
        />
      </g>
      <g
        className="animable"
        id="freepik--character-1--inject-18"
        style={{ transformOrigin: "252.923px 276.32px" }}
      >
        <path
          className="animable"
          id="elaxtm56idf6i"
          style={{
            fill: "rgb(211, 118, 106)",
            transformOrigin: "134.091px 317.605px",
          }}
          d="M179.33,320.71s-35.09,14.92-35.11,14.94c-6.25,4.19-11.8,7.75-14.84,9.33l0,0a5.3,5.3,0,0,1-2.24.83H127c-2.5-1-37.46-50-38.1-52.08s5.34-4.12,8.21-3.3S121.77,304,121.77,304l35.28-14.6Z"
        />
        <path
          className="animable"
          id="elzg02xl3o3so"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "119.57px 318.044px",
          }}
          d="M88.92,293.75c.64,2.12,35.6,51.07,38.1,52.08h.07a5.3,5.3,0,0,0,2.24-.83l0,0c3-1.57,8.59-5.14,14.84-9.33l6.1-2.6-21.94-31.76-6.6,2.74S100,291.28,97.13,290.45,88.26,291.63,88.92,293.75Z"
        />
        <path
          className="animable"
          id="el410vbkjgdu7"
          style={{
            fill: "rgb(0, 185, 143)",
            transformOrigin: "116.68px 318.057px",
          }}
          d="M88.92,293.75c.64,2.12,35.59,51.06,38.11,52.08,1,.4,8.37-4.27,17.19-10.18l.27-.19-22.2-31.83-.52.4S100,291.28,97.13,290.45,88.26,291.64,88.92,293.75Z"
        />
        <path
          className="animable"
          id="eljo7okxzsut"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "108.796px 317.893px",
          }}
          d="M91.21,293c6.09,8.11,29.91,41.37,35.32,49.85,0,.07,0,.1,0,0-6.22-7.91-29.76-41.37-35.41-49.79C91,292.87,91.08,292.78,91.21,293Z"
        />
        <path
          className="animable"
          id="el3nc1qmky22b"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "121.975px 307.109px",
          }}
          d="M119.78,301.44c2.92,2.82,5.26,7.14,4.72,11.28,0,.16-.25.12-.29,0a56.62,56.62,0,0,0-4.83-11A.26.26,0,0,1,119.78,301.44Z"
        />
        <path
          className="animable"
          id="elgvzjp157sw4"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "118.882px 305.769px",
          }}
          d="M116.69,300.11c2.93,2.81,5.26,7.14,4.72,11.27,0,.16-.25.13-.29,0a56.11,56.11,0,0,0-4.83-11A.25.25,0,0,1,116.69,300.11Z"
        />
        <path
          className="animable"
          id="el28639s4mzmw"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "115.805px 304.439px",
          }}
          d="M113.61,298.77c2.92,2.82,5.26,7.14,4.72,11.28,0,.16-.25.12-.29,0a56.62,56.62,0,0,0-4.83-11A.26.26,0,0,1,113.61,298.77Z"
        />
        <path
          className="animable"
          id="el4rou14g7zfv"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "248.63px 301.362px",
          }}
          d="M343,284.08c-.71.21-20.33,7.62-25,8.76-1.39.34-70.4-27-88.38-27.41-26.07-.54-100.43,33.23-100.43,33.23l18.29,38.64s66.45-30.21,84.07-30.21c8.82,0,61.72,21.85,88.24,26.22,32.8,5.4,48.28-17.56,48.28-17.56S346.52,288.48,343,284.08Z"
        />
        <path
          className="animable"
          id="elqzns7uejp9"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "146.441px 313.807px",
          }}
          d="M138.61,296.5c2.83,5.82,2.1,4.11,4.86,10,1.35,2.87,10.22,21.69,11,24.58,0,.07-.08.11-.12.06-1.68-2.49-10.22-21.46-11.51-24.35-2.65-5.9-1.83-4.24-4.41-10.17A.09.09,0,0,1,138.61,296.5Z"
        />
        <path
          className="animable"
          id="elskct1k4vog"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "260.65px 314.759px",
          }}
          d="M157.45,325.48c16.75-7,33.59-13.68,50.76-19.58,4.3-1.45,8.61-2.88,13-4a42.77,42.77,0,0,1,6.74-1.34,13.93,13.93,0,0,1,3.48.21c1.13.19,2.26.4,3.37.66,4.44,1,8.81,2.24,13.17,3.49s8.7,2.59,13,3.93c17.31,5.4,34.51,11.16,51.91,16.21a116.81,116.81,0,0,0,13.17,3.18c4.45.6,9-.3,13.29-1.56a84.64,84.64,0,0,0,12.61-5,120.7,120.7,0,0,0,11.9-6.55,120.66,120.66,0,0,1-11.79,6.77,85.24,85.24,0,0,1-12.58,5.21c-4.33,1.32-8.91,2.28-13.51,1.71a114.35,114.35,0,0,1-13.29-3.06c-8.76-2.4-17.4-5.14-26.06-7.85l-25.95-8.15c-4.32-1.35-8.65-2.68-13-4s-8.7-2.53-13.1-3.53a25.09,25.09,0,0,0-6.59-.87,41.28,41.28,0,0,0-6.59,1.3c-4.36,1.13-8.68,2.51-13,3.92-8.61,2.84-17.12,5.95-25.62,9.12S165.88,322.15,157.45,325.48Z"
        />
        <path
          className="animable"
          id="eli1u1vfftfp"
          style={{
            fill: "rgb(211, 118, 106)",
            transformOrigin: "147.529px 317.933px",
          }}
          d="M184.63,345.64l-38.14,1c-7.35,1.61-13.82,2.89-17.23,3.24h0a5.23,5.23,0,0,1-2.39-.05s0,0-.06,0c-2-1.86-16.55-60.21-16.38-62.42s6.48-1.87,8.85-.06,18,21.66,18,21.66l38.18-.66Z"
        />
        <path
          className="animable"
          id="elyw316zmqyy"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "131.749px 317.914px",
          }}
          d="M110.38,287.43c-.17,2.21,14.42,60.56,16.38,62.42,0,0,0,0,.06,0a5.29,5.29,0,0,0,2.39,0h.06c3.4-.35,9.87-1.63,17.22-3.24l6.63-.19-8.78-37.58-7.15.12s-15.58-19.83-18-21.67S110.55,285.22,110.38,287.43Z"
        />
        <path
          className="animable"
          id="elf196zdwr5k8"
          style={{
            fill: "rgb(0, 185, 143)",
            transformOrigin: "128.594px 317.953px",
          }}
          d="M110.38,287.43c-.18,2.21,14.42,60.56,16.38,62.42.74.72,9.36-.91,19.73-3.18l.32-.07-9-37.75-.64.18s-15.57-19.83-18-21.66S110.55,285.22,110.38,287.43Z"
        />
        <path
          className="animable"
          id="el8oazfx3koew"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "120.025px 317.152px",
          }}
          d="M112.81,287.53c2.7,9.77,12.67,49.45,14.6,59.32,0,.08,0,.09-.06,0-2.89-9.63-12.54-49.38-14.7-59.29C112.6,287.36,112.75,287.32,112.81,287.53Z"
        />
        <path
          className="animable"
          id="el7kruzy2qplk"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "136.805px 311.96px",
          }}
          d="M136.28,305.89c1.69,3.69,2.28,8.58.26,12.22-.08.14-.28,0-.27-.1a55.87,55.87,0,0,0-.48-12A.26.26,0,0,1,136.28,305.89Z"
        />
        <path
          className="animable"
          id="el1kyyvn8x0bd"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "134.425px 309.59px",
          }}
          d="M133.9,303.52c1.69,3.69,2.28,8.57.26,12.22-.08.14-.28,0-.27-.11a55.78,55.78,0,0,0-.48-12A.26.26,0,0,1,133.9,303.52Z"
        />
        <path
          className="animable"
          id="elraxhdgtoxdp"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "132.04px 307.213px",
          }}
          d="M131.51,301.15c1.69,3.69,2.28,8.57.27,12.22-.08.14-.28,0-.27-.11a55.75,55.75,0,0,0-.48-12A.25.25,0,0,1,131.51,301.15Z"
        />
        <path
          className="animable"
          id="elg9ktk9g8hkm"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "257.325px 318.87px",
          }}
          d="M347.32,289.46c-.71.2-29.1,10.45-29.67,11.59s-3.24,8.21-3.92,10.28c0,0-82-7-85.94-7.05-15.9-.21-28.12,2.14-90.14,3.91L147,348.28s73.11-4.23,97.78-4.37c21.14-.13,85.47,3.3,85.47,3.3C363.45,349.16,377,327,377,327S347.35,289.45,347.32,289.46Z"
        />
        <path
          className="animable"
          id="el7zpvdxybwes"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "150.93px 327.296px",
          }}
          d="M147,308.72c1.5,6.3,1.16,4.47,2.6,10.78.7,3.09,5.3,23.38,5.45,26.38,0,.06-.11.08-.13,0-1.11-2.78-5.35-23.15-6-26.25-1.31-6.34-.86-4.54-2.11-10.89A.1.1,0,0,1,147,308.72Z"
        />
        <path
          className="animable"
          id="elv5a0x6nlga"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "313.923px 306.889px",
          }}
          d="M314.05,300.09a77.9,77.9,0,0,1,0,13.66.14.14,0,0,1-.28,0c-.13-4.54-.36-9.13-.24-13.67A.27.27,0,0,1,314.05,300.09Z"
        />
        <path
          className="animable"
          id="elyesslojoht8"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "330.58px 300.239px",
          }}
          d="M341.55,291.84c.14,0,.26.19.11.24a137.33,137.33,0,0,0-12.87,5.41c-2,.91-12.54,6.59-10.45,9.8.35.53,1,.62,2,.39a14.91,14.91,0,0,0,3.26-1.7c2.2-1.24,4.43-2.4,6.72-3.46a67.72,67.72,0,0,1,13.26-4.64.12.12,0,0,1,.07.23,128.46,128.46,0,0,0-17.85,7.67c-2.75,1.5-6.59,4.54-8.14,1.67s5-7.59,6.89-8.69A71.21,71.21,0,0,1,341.55,291.84Z"
        />
        <path
          className="animable"
          id="elr0lknplrpip"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "316.086px 308.261px",
          }}
          d="M318,307.3a18.81,18.81,0,0,1-2,1.63,5.46,5.46,0,0,1-1.78,1c-.13,0-.2-.13-.14-.23a6.87,6.87,0,0,1,1.56-1.48c.62-.53,1.22-1.07,1.86-1.58A.42.42,0,0,1,318,307.3Z"
        />
        <path
          className="animable"
          id="el4uwd2lfd2mn"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "225.719px 307.709px",
          }}
          d="M227.26,303.81c6.15-.1,85.43,7.37,86.47,7.52.11,0,.06.28,0,.28-3.64-.07-80.92-7-86.38-6.75-3.91.18-85.72,3.32-89.62,3.41-.11,0-.12-.17,0-.18C144.61,307.17,226.44,303.82,227.26,303.81Z"
        />
        <path
          className="animable"
          id="elt1syx08iak"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "265.358px 335.308px",
          }}
          d="M195.83,338.92c13.2-.76,26.45-1.07,39.67-1.07s26.59.35,39.86,1.06,26.53,1.82,39.74,3.27A158.5,158.5,0,0,0,334,343.51a49.47,49.47,0,0,0,18.46-3.66c6.48-2.71,20.35-12.85,21.66-13.77.09-.06.21.07.12.13-10.11,7.45-22.28,22.07-52.59,17.46-6.49-1-13.06-1.33-19.6-1.89q-10.06-.87-20.16-1.46c-13.34-.79-26.68-1.3-40-1.42s-26.71.11-40.05.68-26.74,1.55-40.1,2.5c-1.74.12-3.48.3-5.21.48-.1,0-.13-.14,0-.15C169.53,341,182.64,339.68,195.83,338.92Z"
        />
        <path
          className="animable"
          id="elhuul6pk6ipp"
          style={{
            fill: "rgb(211, 118, 106)",
            transformOrigin: "346.429px 248.663px",
          }}
          d="M376.29,261.09c-15.87,7.39-38.34,13.62-43.94,10.67-4.52-2.38-24-32.22-24.72-35.66-.63-3,20.39-13.36,22.52-10.91,3.56,4.11,13.12,25.08,14.58,25.54s18-1.4,31.72-1.64C389.06,248.87,387.3,256,376.29,261.09Z"
        />
        <path
          className="animable"
          id="elm4v5mwbl7a"
          style={{
            fill: "rgb(211, 118, 106)",
            transformOrigin: "314.326px 221.239px",
          }}
          d="M309.56,239.86c-1.6-2.31-8-13.57-9.09-17.1s-3.46-13.92-.84-15,3.56,1.88,3.56,1.88-.31-4.55,2.43-5.42,4,3.82,4,3.82,0-4.69,2.82-5.36,3.32,4.26,3.32,4.26-.18-4.29,2.35-3.87c3.05.5,2.49,8.44,4,12.25.34.87,8.1,17,8.1,17Z"
        />
        <path
          className="animable"
          id="elb1tygh7o09v"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "316.953px 213.231px",
          }}
          d="M315.75,206.5c-.4,5.85.43,8.47,3.17,13.55.06.1-.08.2-.14.1-3.14-4.72-4.66-7.87-3.32-13.68C315.53,206.18,315.76,206.22,315.75,206.5Z"
        />
        <path
          className="animable"
          id="el0qod5tyxx6pa"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "311.206px 214.763px",
          }}
          d="M309.7,207.56c.12,6.11,1,9,3.48,14.49a.08.08,0,0,1-.14.07c-2.88-5.22-4.33-8.39-3.64-14.51C309.43,207.34,309.7,207.28,309.7,207.56Z"
        />
        <path
          className="animable"
          id="eljjrp2j38u2"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "305.451px 216.908px",
          }}
          d="M303.32,209.89c.54,5.91,1.37,9.08,4.47,14.14a.11.11,0,0,1-.18.12c-3.66-4.84-4.73-8.8-4.47-14.22C303.16,209.56,303.29,209.52,303.32,209.89Z"
        />
        <path
          className="animable"
          id="el0m2sdnd6z4xq"
          style={{
            fill: "rgb(211, 118, 106)",
            transformOrigin: "326.925px 222.276px",
          }}
          d="M334.43,234.36s.91-7.29.6-10.58-5.95-15.12-8.58-14c-3.39,1.39-1.47,8.86-.06,12.4,0,0-7.84,3.2-7.63,8.87S334.43,234.36,334.43,234.36Z"
        />
        <path
          className="animable"
          id="elr3a196nbtf"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "322.591px 220.64px",
          }}
          d="M325.64,210.42c-2.17,3.5,0,8,1.1,11.56a.34.34,0,0,1-.32.46c-3.19,1.56-7.25,4.69-7.83,8.41a.09.09,0,0,1-.17,0c.08-4.07,3.81-7.48,7.43-9-1.21-3.61-3.17-8.24-.24-11.48C325.63,210.38,325.66,210.4,325.64,210.42Z"
        />
        <path
          className="animable"
          id="elr5kecak4lgd"
          style={{
            fill: "rgb(0, 185, 143)",
            transformOrigin: "347.93px 254.048px",
          }}
          d="M336.88,234.89l-27.33,12.84s16.75,23.19,23.19,25,21.79-1.45,44.5-11.5c15.39-6.81,8.66-13-1.5-12.41-7.36.4-29.67,1.81-30.6.7S336.88,234.89,336.88,234.89Z"
        />
        <path
          className="animable"
          id="eloe70tfog1k"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "349.842px 256.277px",
          }}
          d="M372.28,260.91a1.57,1.57,0,0,1-.63-.22,1.18,1.18,0,0,1-.55-1,1.61,1.61,0,0,0-1-1.44,1.57,1.57,0,0,0-.85,0,6.74,6.74,0,0,0-.78.16c.26.06.51.09.78.14a1.56,1.56,0,0,1,.65.2,1.23,1.23,0,0,1,.57,1,1.6,1.6,0,0,0,1,1.46,1.48,1.48,0,0,0,.85.09c.26-.06.51-.09.76-.16C372.79,261,372.54,261,372.28,260.91Zm-27.06,6.46a1.52,1.52,0,0,1-.63-.22,1.18,1.18,0,0,1-.55-1,1.61,1.61,0,0,0-1-1.44,1.57,1.57,0,0,0-.85-.05,6.74,6.74,0,0,0-.78.16c.26.06.51.09.78.14a1.56,1.56,0,0,1,.65.2,1.23,1.23,0,0,1,.57,1,1.6,1.6,0,0,0,1,1.46,1.47,1.47,0,0,0,.85.09c.26-.06.51-.09.76-.16A6.38,6.38,0,0,0,345.22,267.37Zm-15-24.56a1.57,1.57,0,0,1-.63-.22,1.18,1.18,0,0,1-.54-1,1.61,1.61,0,0,0-1-1.44,1.67,1.67,0,0,0-.85-.05,6.74,6.74,0,0,0-.78.16c.26.06.51.09.78.14a1.72,1.72,0,0,1,.64.2,1.21,1.21,0,0,1,.58,1,1.59,1.59,0,0,0,1,1.46,1.49,1.49,0,0,0,.85.09c.27-.06.52-.09.77-.16C330.7,242.89,330.45,242.86,330.18,242.81ZM357,254.37c0-.27-.08-.52-.14-.77a6.17,6.17,0,0,0-.16.77,1.46,1.46,0,0,1-.2.64,1.18,1.18,0,0,1-1,.59,1.6,1.6,0,0,0-1.46,1,1.52,1.52,0,0,0-.09.86c.06.25.09.5.16.77a5.79,5.79,0,0,0,.15-.77,1.35,1.35,0,0,1,.22-.64,1.2,1.2,0,0,1,1-.55,1.53,1.53,0,0,0,1.49-1.87Zm-40.52-7.23c-.05-.27-.09-.52-.15-.77-.07.25-.1.5-.16.77a1.51,1.51,0,0,1-.2.64,1.15,1.15,0,0,1-1,.58,1.59,1.59,0,0,0-1.46,1,1.51,1.51,0,0,0-.09.86c.06.25.09.5.15.76a7.37,7.37,0,0,0,.16-.76,1.35,1.35,0,0,1,.22-.64,1.21,1.21,0,0,1,1-.56,1.57,1.57,0,0,0,1.44-1A1.66,1.66,0,0,0,316.5,247.14Zm11.38,12c-.05-.27-.08-.52-.14-.77a6.17,6.17,0,0,0-.16.77,1.51,1.51,0,0,1-.2.64,1.17,1.17,0,0,1-1,.58,1.59,1.59,0,0,0-1.46,1,1.51,1.51,0,0,0-.09.86c.06.25.09.5.16.76a5.37,5.37,0,0,0,.15-.76,1.35,1.35,0,0,1,.22-.64,1.23,1.23,0,0,1,1-.56,1.56,1.56,0,0,0,1.44-1A1.52,1.52,0,0,0,327.88,259.17Zm58.34-6.54a1.06,1.06,0,0,1-.56-.34,1.59,1.59,0,0,0-1.74-.29,1.51,1.51,0,0,0-.65.56c-.14.22-.31.43-.44.66.24-.14.44-.3.66-.44a1.3,1.3,0,0,1,.59-.31,1.2,1.2,0,0,1,1.14.28,1.53,1.53,0,0,0,1.09.48A2.89,2.89,0,0,0,386.22,252.63Zm-50.6,19a1.19,1.19,0,0,1-.59.3,1.17,1.17,0,0,1-1.12-.34,1.58,1.58,0,0,0-1.74-.3,1.53,1.53,0,0,0-.64.56l-.16.23.2.11.18-.12a1.33,1.33,0,0,1,.6-.31,1.17,1.17,0,0,1,1.12.28,1.55,1.55,0,0,0,1.71.36,1.61,1.61,0,0,0,.68-.55c.14-.22.29-.42.42-.66Zm4.91-18.92a1.26,1.26,0,0,1-.6.3,1.16,1.16,0,0,1-1.11-.34,1.61,1.61,0,0,0-1.74-.3,1.51,1.51,0,0,0-.65.56c-.14.22-.31.43-.44.66.24-.14.44-.3.66-.44a1.38,1.38,0,0,1,.6-.31,1.19,1.19,0,0,1,1.13.28,1.54,1.54,0,0,0,1.71.36,1.58,1.58,0,0,0,.67-.55c.14-.22.3-.42.43-.66C341,252.42,340.75,252.57,340.53,252.71Z"
        />
        <path
          className="animable"
          id="el8cqinvklp3s"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "326.344px 246.258px",
          }}
          d="M338.5,240.79c-3.9,2.15-7.91,4.12-11.94,6-2,.93-4,1.85-6,2.7s-4.25,1.65-6.34,2.55a.08.08,0,0,1-.07-.15c2.05-.95,4-2.07,6.07-3.07s3.95-1.88,5.92-2.81c4-1.89,8.09-3.77,12.19-5.52A.17.17,0,0,1,338.5,240.79Z"
        />
        <path
          className="animable"
          id="el8dq4ky0yxtl"
          style={{
            fill: "rgb(0, 185, 143)",
            transformOrigin: "363.895px 292.358px",
          }}
          d="M331,287c.15,1.85,41.48,48.13,41.95,48,1.25-.28,28.34-47.72,23.19-76.66-.91-5.1-8-9.31-12.53-8.53-10.11,1.73-38,27.49-39.93,28.89C340.07,281.26,331,286.51,331,287Z"
        />
        <path
          className="animable"
          id="el4fxpp37voo"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "364.31px 292.506px",
          }}
          d="M372.28,260.91a1.57,1.57,0,0,1-.63-.22,1.18,1.18,0,0,1-.55-1,1.61,1.61,0,0,0-1-1.44,1.57,1.57,0,0,0-.85,0,6.74,6.74,0,0,0-.78.16c.26.06.51.09.78.14a1.56,1.56,0,0,1,.65.2,1.23,1.23,0,0,1,.57,1,1.6,1.6,0,0,0,1,1.46,1.48,1.48,0,0,0,.85.09c.26-.06.51-.09.76-.16C372.79,261,372.54,261,372.28,260.91Zm-29,29a1.57,1.57,0,0,1-.63-.22,1.19,1.19,0,0,1-.54-1,1.63,1.63,0,0,0-1-1.45,1.66,1.66,0,0,0-.85,0,5.53,5.53,0,0,0-.79.16c.27.06.52.09.79.14a1.56,1.56,0,0,1,.64.2,1.2,1.2,0,0,1,.58,1,1.6,1.6,0,0,0,1,1.46,1.49,1.49,0,0,0,.85.09c.27-.06.52-.09.77-.16A4.77,4.77,0,0,0,343.3,290Zm42.33,19.1a1.55,1.55,0,0,0-.85,0c-.25,0-.51.08-.77.14a5.5,5.5,0,0,0,.77.15,1.61,1.61,0,0,1,.64.21,1.22,1.22,0,0,1,.46.47c.08-.2.17-.4.25-.61A1.26,1.26,0,0,0,385.63,309.06Zm-12.78,23.72a1.32,1.32,0,0,1-.64-.22,1.17,1.17,0,0,1-.55-1,1.59,1.59,0,0,0-1-1.45,1.62,1.62,0,0,0-.84,0c-.25,0-.52.08-.77.14a5.23,5.23,0,0,0,.77.15,1.72,1.72,0,0,1,.64.21,1.19,1.19,0,0,1,.59,1,1.56,1.56,0,0,0,1,1.46,1.53,1.53,0,0,0,.86.1l.77-.16C373.35,332.86,373.1,332.83,372.85,332.78Zm-1.8-28.63a1.57,1.57,0,0,1-.64-.22,1.22,1.22,0,0,1-.55-1,1.55,1.55,0,0,0-1.87-1.5c-.26.06-.51.09-.77.16.26.07.51.1.77.15a1.32,1.32,0,0,1,.65.21,1.19,1.19,0,0,1,.6,1,1.55,1.55,0,0,0,.95,1.46,1.43,1.43,0,0,0,.86.08c.25-.05.5-.08.77-.16C371.55,304.23,371.3,304.2,371.05,304.15Zm10.26-21.36a1.34,1.34,0,0,1-.62-.21,1.16,1.16,0,0,1-.55-1,1.59,1.59,0,0,0-1-1.44,1.4,1.4,0,0,0-.85-.06l-.78.15a6.74,6.74,0,0,0,.78.16,1.51,1.51,0,0,1,.64.19,1.2,1.2,0,0,1,.58,1,1.63,1.63,0,0,0,1,1.48,1.48,1.48,0,0,0,.85.07,5.49,5.49,0,0,0,.79-.15C381.83,282.88,381.58,282.85,381.31,282.79ZM353.73,281a1.56,1.56,0,0,1-.63-.2,1.21,1.21,0,0,1-.55-1,1.58,1.58,0,0,0-1-1.44,1.4,1.4,0,0,0-.85-.06l-.79.15a7.37,7.37,0,0,0,.79.16,1.55,1.55,0,0,1,.64.19,1.2,1.2,0,0,1,.58,1,1.6,1.6,0,0,0,1,1.48,1.48,1.48,0,0,0,.85.07,5.12,5.12,0,0,0,.78-.15C354.25,281.05,354,281,353.73,281Zm12.42,5a4.77,4.77,0,0,0-.15-.77c-.06.25-.1.5-.16.77a1.42,1.42,0,0,1-.19.64,1.15,1.15,0,0,1-1,.58,1.63,1.63,0,0,0-1.47,1,1.57,1.57,0,0,0-.08.85c0,.27.08.52.15.79a5.53,5.53,0,0,0,.16-.79,1.32,1.32,0,0,1,.22-.63,1.18,1.18,0,0,1,1-.54,1.61,1.61,0,0,0,1.44-1A1.47,1.47,0,0,0,366.15,286Zm-8,25.32a4.77,4.77,0,0,0-.15-.77c-.06.25-.1.5-.16.77a1.42,1.42,0,0,1-.19.64,1.15,1.15,0,0,1-1,.58,1.63,1.63,0,0,0-1.47,1,1.57,1.57,0,0,0-.08.85,7.32,7.32,0,0,0,.15.79,7.37,7.37,0,0,0,.16-.79,1.32,1.32,0,0,1,.22-.63,1.17,1.17,0,0,1,1-.54,1.63,1.63,0,0,0,1.45-1A1.47,1.47,0,0,0,358.12,311.31Zm31-44.4c-.07-.25-.1-.5-.16-.77-.08.27-.11.52-.16.77a1.51,1.51,0,0,1-.2.66,1.17,1.17,0,0,1-1,.59,1.56,1.56,0,0,0-1.46,1,1.24,1.24,0,0,0-.08.84c.05.27.08.52.14.77.07-.25.11-.5.16-.77a1.44,1.44,0,0,1,.22-.63,1.16,1.16,0,0,1,1-.54,1.58,1.58,0,0,0,1.44-1A1.88,1.88,0,0,0,389.11,266.91Zm-1.74-14.57a1.47,1.47,0,0,1-.6.3,1.15,1.15,0,0,1-1.11-.35,1.59,1.59,0,0,0-1.74-.29,1.51,1.51,0,0,0-.65.56c-.14.22-.31.43-.44.66.24-.14.44-.3.66-.44a1.3,1.3,0,0,1,.59-.31,1.2,1.2,0,0,1,1.14.28,1.53,1.53,0,0,0,1.7.36,1.55,1.55,0,0,0,.68-.55c.14-.22.3-.42.43-.66C387.79,252,387.59,252.2,387.37,252.34Zm-17.8,20.6a1.17,1.17,0,0,1-.59.29,1.15,1.15,0,0,1-1.12-.34,1.6,1.6,0,0,0-1.74-.3,1.49,1.49,0,0,0-.64.57,7.57,7.57,0,0,0-.44.66c.23-.15.44-.31.66-.44a1.22,1.22,0,0,1,.6-.32,1.15,1.15,0,0,1,1.12.29,1.56,1.56,0,0,0,1.71.35,1.52,1.52,0,0,0,.68-.54c.14-.22.29-.43.42-.66C370,272.64,369.79,272.79,369.57,272.94ZM375,316.35a1.19,1.19,0,0,1-.59.3,1.17,1.17,0,0,1-1.12-.34,1.58,1.58,0,0,0-1.74-.3,1.53,1.53,0,0,0-.64.56c-.14.22-.32.43-.44.66.23-.14.44-.3.66-.44a1.33,1.33,0,0,1,.6-.31,1.17,1.17,0,0,1,1.12.28,1.55,1.55,0,0,0,1.71.36,1.61,1.61,0,0,0,.68-.55c.14-.22.29-.42.42-.66Zm-20.6-18.11a1.25,1.25,0,0,1-1.72,0,1.57,1.57,0,0,0-1.73-.31,1.71,1.71,0,0,0-.64.57,5.82,5.82,0,0,0-.44.66c.23-.13.44-.29.66-.44a1.38,1.38,0,0,1,.59-.32,1.21,1.21,0,0,1,1.12.3,1.59,1.59,0,0,0,1.72.36,1.5,1.5,0,0,0,.66-.54c.14-.22.32-.43.44-.66C354.81,297.94,354.6,298.1,354.38,298.24Zm31.46-2.15a1.45,1.45,0,0,1-.61.3,1.22,1.22,0,0,1-1.11-.34,1.55,1.55,0,0,0-1.75-.31,1.78,1.78,0,0,0-.64.57c-.14.21-.29.41-.44.64a6.9,6.9,0,0,0,.67-.43,2,2,0,0,1,.59-.32,1.21,1.21,0,0,1,1.13.3,1.58,1.58,0,0,0,1.71.36,1.63,1.63,0,0,0,.68-.55c.13-.22.29-.42.41-.66C386.26,295.78,386.07,295.93,385.84,296.09Z"
        />
        <path
          className="animable"
          id="elq9nr7zn7w1f"
          style={{
            fill: "rgb(211, 118, 106)",
            transformOrigin: "389.042px 290.579px",
          }}
          d="M400,261.23c7.24,14.55,19.77,44.31,14.47,52s-32.59,11.18-41.92,12.25c-3.07.35-12.7-22-9.6-23.14,5.27-1.95,29.9-4.86,30.77-6.46.56-1-3-20.22-2.92-31.39C390.94,250,397.73,256.71,400,261.23Z"
        />
        <path
          className="animable"
          id="elzurcm0uu9j"
          style={{
            fill: "rgb(211, 118, 106)",
            transformOrigin: "348.586px 317.374px",
          }}
          d="M365.64,301.6s-9.66.74-15.95,1.52c-3.51.44-9.47,1.72-11.9,3.22-3.64,2.24-17.43,14-14.67,17.35,2.51,3.09,13.08-8.48,13.08-8.48s-11.7,10.73-8,13.88,13.9-11.49,13.9-11.49-11.77,11.29-7.44,13.94c3.27,2,13.26-10.74,13.26-10.74s-10.05,9.77-6.78,12c3.62,2.44,13.58-8.75,13.58-8.75,9.27,4.21,15.4,2.42,19.62.63C375.36,324.22,365.64,301.6,365.64,301.6Z"
        />
        <path
          className="animable"
          id="el1nox46olzzb"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "334.09px 318.235px",
          }}
          d="M340,311.25c-1.42,1.21-2.87,2.42-4.18,3.75s-2.57,2.71-3.74,4.16a32.37,32.37,0,0,0-4,6.07,68.56,68.56,0,0,1,8.17-9.88c1.31-1.33,2.54-2.73,3.85-4.06C340.09,311.26,340,311.22,340,311.25Z"
        />
        <path
          className="animable"
          id="elmfywijuz12q"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "339.965px 320.996px",
          }}
          d="M344.9,315.88c-1.74,1.62-3.54,3.17-5.21,4.87s-3.1,3.45-4.65,5.25c-.12.14,0,.16.12,0,1.62-1.74,3.25-3.22,4.88-4.94s3.21-3.51,4.9-5.16A0,0,0,1,0,344.9,315.88Z"
        />
        <path
          className="animable"
          id="elmik7glx0p4j"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "346.155px 323.177px",
          }}
          d="M349.82,319.1a52.37,52.37,0,0,0-7.4,8.06c-.12.14,0,.15.16,0,2.41-2.72,4.28-4.88,7.32-8C350,319.15,349.88,319.05,349.82,319.1Z"
        />
        <path
          className="animable"
          id="elhiup6rf9ekp"
          style={{
            fill: "rgb(0, 185, 143)",
            transformOrigin: "390.897px 290.622px",
          }}
          d="M364.8,301.08l18,25.29s28.55-4.7,33.16-14.06-7.3-37.2-14.11-48.84-11.59-11.67-11.51,1.2c.08,11.52,3.18,30.23,2.7,30.83S364.8,301.08,364.8,301.08Z"
        />
        <path
          className="animable"
          id="el6dw4fg4eh6p"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "392.04px 292.33px",
          }}
          d="M402.67,265l-.14,0a1.44,1.44,0,0,1-.63-.22,1.18,1.18,0,0,1-.55-1,1.6,1.6,0,0,0-1-1.44,1.66,1.66,0,0,0-.85-.05,7.72,7.72,0,0,0-.78.16c.27.06.52.09.78.14a1.91,1.91,0,0,1,.65.2,1.21,1.21,0,0,1,.58,1,1.58,1.58,0,0,0,1,1.46,1.49,1.49,0,0,0,.85.09l.27-.05C402.75,265.11,402.71,265,402.67,265Zm-14.83,46.81a1.29,1.29,0,0,1-.64-.22,1.17,1.17,0,0,1-.55-1,1.59,1.59,0,0,0-1-1.45,1.55,1.55,0,0,0-.85,0c-.25,0-.51.08-.77.14a5.5,5.5,0,0,0,.77.15,1.61,1.61,0,0,1,.64.21,1.18,1.18,0,0,1,.6,1,1.56,1.56,0,0,0,1,1.46,1.52,1.52,0,0,0,.86.1l.77-.16C388.34,311.84,388.09,311.81,387.84,311.76Zm-16.79-7.61a1.57,1.57,0,0,1-.64-.22,1.22,1.22,0,0,1-.55-1,1.55,1.55,0,0,0-1.87-1.5c-.26.06-.51.09-.77.16.26.07.51.1.77.15a1.32,1.32,0,0,1,.65.21,1.19,1.19,0,0,1,.6,1,1.55,1.55,0,0,0,.95,1.46,1.43,1.43,0,0,0,.86.08c.25-.05.5-.08.77-.16C371.55,304.23,371.3,304.2,371.05,304.15Zm45.7-.74a1.09,1.09,0,0,1-.41-.91,1.61,1.61,0,0,0-1-1.45,1.48,1.48,0,0,0-.85-.06c-.27.06-.52.09-.78.16a5.12,5.12,0,0,0,.78.15,1.51,1.51,0,0,1,.64.19,1.2,1.2,0,0,1,.58,1,1.62,1.62,0,0,0,1,1.47l.15.06C416.8,303.83,416.78,303.62,416.75,303.41Zm-15.16-7.26a1.28,1.28,0,0,1-.63-.22,1.16,1.16,0,0,1-.54-1,1.58,1.58,0,0,0-1-1.44,1.63,1.63,0,0,0-.87,0c-.25,0-.5.08-.76.14a7.37,7.37,0,0,0,.76.16,1.56,1.56,0,0,1,.66.2,1.18,1.18,0,0,1,.58,1,1.59,1.59,0,0,0,1,1.46,1.46,1.46,0,0,0,.86.1c.27-.07.52-.1.77-.16A6.17,6.17,0,0,0,401.59,296.15Zm-1-16.86a1.85,1.85,0,0,1-.6.34,1.24,1.24,0,0,1-1.13-.3,1.58,1.58,0,0,0-1.71-.36,1.35,1.35,0,0,0-.67.54c-.15.23-.31.43-.44.67l.66-.44a1.38,1.38,0,0,1,.59-.3,1.23,1.23,0,0,1,1.13.34,1.58,1.58,0,0,0,1.74.3,1.64,1.64,0,0,0,.65-.57c.13-.22.29-.41.42-.65C401,279,400.82,279.16,400.6,279.29Zm11.65,6.88a1.52,1.52,0,0,0-1.25.95,1.33,1.33,0,0,0-.08.85c.05.26.08.51.14.76a6.41,6.41,0,0,0,.16-.76,1.52,1.52,0,0,1,.22-.63,1.15,1.15,0,0,1,1-.55C412.4,286.58,412.33,286.38,412.25,286.17Zm.17,28.17c-.06-.25-.09-.5-.16-.77a5.79,5.79,0,0,0-.15.77,1.51,1.51,0,0,1-.21.66,1.17,1.17,0,0,1-1,.58,1.55,1.55,0,0,0-1.46,1,1.3,1.3,0,0,0-.08.84c0,.24.07.46.12.68h0l0,.08,0-.11a6.42,6.42,0,0,0,.13-.66,1.57,1.57,0,0,1,.22-.63,1.18,1.18,0,0,1,1-.55,1.6,1.6,0,0,0,1.45-1A1.87,1.87,0,0,0,412.42,314.34Zm-37,1.71.07.09a1.76,1.76,0,0,0,.14-.23Zm27.24-8.67a1.5,1.5,0,0,1-.59.3,1.27,1.27,0,0,1-1.13-.34,1.57,1.57,0,0,0-1.73-.3,1.48,1.48,0,0,0-.64.56c-.15.22-.31.43-.44.66.23-.14.44-.29.66-.44a1.47,1.47,0,0,1,.6-.32,1.17,1.17,0,0,1,1.11.29,1.59,1.59,0,0,0,1.72.36,1.45,1.45,0,0,0,.66-.55,5.82,5.82,0,0,0,.44-.66Zm-6.86,14.09a1.38,1.38,0,0,1-.59.3,1.22,1.22,0,0,1-1.13-.34,1.59,1.59,0,0,0-1.73-.3,1.48,1.48,0,0,0-.64.56,6.88,6.88,0,0,0-.44.66c.23-.14.44-.29.66-.44a1.47,1.47,0,0,1,.6-.32,1.17,1.17,0,0,1,1.11.29,1.59,1.59,0,0,0,1.72.36,1.51,1.51,0,0,0,.66-.55,5.82,5.82,0,0,0,.44-.66C396.24,321.18,396,321.34,395.81,321.47Z"
        />
        <path
          className="animable"
          id="elxdg3xqq09cl"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "379.803px 312.036px",
          }}
          d="M372.18,301.1c2.83,3.44,5.5,7,8.09,10.64,1.27,1.78,2.55,3.56,3.75,5.38s2.4,3.88,3.66,5.77c.06.08-.07.18-.13.09-1.31-1.84-2.77-3.59-4.13-5.4s-2.57-3.54-3.84-5.31c-2.6-3.63-5.19-7.26-7.66-11A.16.16,0,0,1,372.18,301.1Z"
        />
        <path
          className="animable"
          id="el2gi1xfhjt2w"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "378.638px 289.111px",
          }}
          d="M364.89,301.6c.07.06.37.13.25,0s-.38-.48-.34-.49L393.2,296c.05,0-.75-8.28-.92-9.84q-.54-4.79-1.27-9.56c0-.07-.13-.07-.13,0,0,1.92.13,3.85.26,5.76-.23-.85-.49-1.69-.8-2.51,0-.07-.14,0-.12,0,.32,1.63.71,3.26,1.11,4.88,0,.43.05.85.1,1.28.16,1.6.34,3.2.54,4.79.1.78.22,3.51.31,4.32-3.48.46-26.16,4.93-28.2,5.57C364,300.78,364.82,301.55,364.89,301.6Z"
        />
        <path
          className="animable"
          id="elba8ljmpnmkm"
          style={{
            fill: "rgb(211, 118, 106)",
            transformOrigin: "389.88px 249.37px",
          }}
          d="M381.66,258.38c2.77,1.91,9.84-.71,13.38-3.69.24-.2,3.2-11,4-13.07.17-.42-14.27-1.91-14.27-1.91a35.43,35.43,0,0,1-1.84,8.46C382.81,248.48,379,256.53,381.66,258.38Z"
        />
        <path
          className="animable"
          id="elzl8ed1fuhf"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "390.59px 244.949px",
          }}
          d="M384.77,239.71h0c0,.07,0,.35-.08.8-.1.77-.26,2-.55,3.39a25.36,25.36,0,0,1-1.21,4.26c0,.1-.09.2-.12.29l0,0c-.08.17-.18.39-.29.66a9.58,9.58,0,0,0,1.24.56c7.16,2.6,12.94-5.18,14.9-8.26l-.24-.05c-.36-.08-.86-.16-1.45-.26l-.45-.06c-.95-.14-2.08-.28-3.27-.44l-1.18-.14-2.51-.29-1-.11-1-.11c-.16,0-.32,0-.47-.06l-.22,0-1.2-.12-.57-.06a1.36,1.36,0,0,0-.24,0h-.05Z"
        />
        <path
          className="animable"
          id="elk10y679r13"
          style={{
            fill: "rgb(211, 118, 106)",
            transformOrigin: "392.261px 231.289px",
          }}
          d="M406.1,226.5c0,5.18-6.8,18.06-11.12,20.06-6.26,2.88-14.39.81-16.31-6.23-1.87-6.82,7.25-23.45,11.88-25.05C397.36,212.94,406.15,218.84,406.1,226.5Z"
        />
        <path
          className="animable"
          id="elc4vdezrdyyv"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "389.785px 231.585px",
          }}
          d="M390.09,230.17s.05.08,0,.11c-.43.9-.79,2-.1,2.67a0,0,0,0,1,0,.05C389.05,232.4,389.53,231,390.09,230.17Z"
        />
        <path
          className="animable"
          id="elc16wpwn82jg"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "390.818px 231.097px",
          }}
          d="M391.33,229.59c1.51.55.3,3.53-1.1,3S390.06,229.13,391.33,229.59Z"
        />
        <path
          className="animable"
          id="el7i6ms11186m"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "384.309px 228.727px",
          }}
          d="M385.29,227.69s-.09,0-.1.05c-.34.94-.88,1.95-1.84,1.93,0,0-.05.05,0,.06C384.41,230,385.12,228.63,385.29,227.69Z"
        />
        <path
          className="animable"
          id="elyboqyen6f4"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "384.107px 227.828px",
          }}
          d="M384.85,226.39c-1.45-.7-2.75,2.24-1.41,2.89S386.06,227,384.85,226.39Z"
        />
        <path
          className="animable"
          id="el4gykurc25gy"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "387.045px 238.036px",
          }}
          d="M388,237.89a1.54,1.54,0,0,1-1,.27,2.73,2.73,0,0,1-.92-.59s-.07,0-.06,0a1.34,1.34,0,0,0,1,.93,1.06,1.06,0,0,0,1-.57C388.12,237.91,388.05,237.87,388,237.89Z"
        />
        <path
          className="animable"
          id="el8iz9w0tjp3y"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "386.219px 230.045px",
          }}
          d="M384.93,232.38s-.76,1.29-1,1.94a14.69,14.69,0,0,1,3.52,2.11c.24.22.34,0,.1-.35a6,6,0,0,0-2.82-2.09c0-.2,1.21-2,1.11-2a5.93,5.93,0,0,0-1.61-.28c1.52-2.74,3.46-5.21,4.92-8a.1.1,0,0,0-.15-.12A50.15,50.15,0,0,0,383.3,232C383.09,232.31,384.62,232.38,384.93,232.38Z"
        />
        <path
          className="animable"
          id="eljs4yaekj6sd"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "386.555px 236.16px",
          }}
          d="M385.36,235a3.83,3.83,0,0,0,1.26,2.12c1.06.63,1.6-.33.6-1.41A3.75,3.75,0,0,0,385.36,235Z"
        />
        <path
          className="animable"
          id="eltlxpsbkzqcf"
          style={{
            fill: "rgb(255, 153, 186)",
            transformOrigin: "386.74px 236.592px",
          }}
          d="M386.62,237.11a2.47,2.47,0,0,1-.88-1.06c.37-.25,1.07-.42,2,.73C387.75,237.29,387.29,237.51,386.62,237.11Z"
        />
        <path
          className="animable"
          id="el6qs4da90652"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "393.031px 227.621px",
          }}
          d="M394.35,227.82a11.37,11.37,0,0,0-1-.88,2.14,2.14,0,0,0-1.15-.71.68.68,0,0,0-.66.48,1.66,1.66,0,0,0,.64,1.56,2.49,2.49,0,0,0,1.6.74A.71.71,0,0,0,394.35,227.82Z"
        />
        <path
          className="animable"
          id="elhkk7qfphnb"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "385.907px 223.949px",
          }}
          d="M384.8,223.07c.44,0,.86,0,1.3,0a2.14,2.14,0,0,1,1.32.25.65.65,0,0,1,.17.8,1.64,1.64,0,0,1-1.52.72,2.48,2.48,0,0,1-1.68-.52A.72.72,0,0,1,384.8,223.07Z"
        />
        <path
          className="animable"
          id="ely16elppmtp"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "398.064px 222.308px",
          }}
          d="M402.69,238.07s7-7,7.7-11.93c.31-2.21-2.27-4.38-2.27-4.38a5,5,0,0,0-.35-5.28c-2-3-8.28-4-8.28-4s-2.6-6.76-8.83-5.85-4.09,8.24-4.09,8.24-2.8,2.45,1.72,6,15,3.7,15,3.7A36.26,36.26,0,0,0,401,235.09,3.3,3.3,0,0,0,402.69,238.07Z"
        />
        <path
          className="animable"
          id="el5ktf2ly6wi5"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "403.836px 217.338px",
          }}
          d="M398.49,212.34a10.12,10.12,0,0,1,4.17.24,10.87,10.87,0,0,1,3.45,1.43,6.13,6.13,0,0,1,3.11,5.49,4.31,4.31,0,0,1-1.55,2.95s-.08,0-.05-.07c1.71-1.3,1.63-4,.61-5.68a9.25,9.25,0,0,0-5.44-3.66,17.79,17.79,0,0,0-4.29-.57A.07.07,0,0,1,398.49,212.34Z"
        />
        <path
          className="animable"
          id="eluouklnrdrdc"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "392.179px 211.538px",
          }}
          d="M386,208.41a4.94,4.94,0,0,1,4.11-2.28,8.49,8.49,0,0,1,5.32,1.49,10.63,10.63,0,0,1,3.59,4.32s0,.07-.06,0a9.42,9.42,0,0,0-8-5.39,5.18,5.18,0,0,0-4.23,1.6,5.09,5.09,0,0,0-.9,4.24,9.62,9.62,0,0,0,2.76,4.54s0,.07-.05,0a9.87,9.87,0,0,1-2.87-4A5.55,5.55,0,0,1,386,208.41Z"
        />
        <path
          className="animable"
          id="ely9mqn8n0jli"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "396.556px 222.987px",
          }}
          d="M387,220.85a17.63,17.63,0,0,0,6.83,3,36,36,0,0,0,7.75.79c1.52,0,3-.05,4.55-.13,0,0,.05.07,0,.07a39.32,39.32,0,0,1-8.25.51,19.71,19.71,0,0,1-7.39-1.87,16.73,16.73,0,0,1-3.53-2.3S387,220.83,387,220.85Z"
        />
        <path
          className="animable"
          id="elizx08j7huum"
          style={{
            fill: "rgb(211, 118, 106)",
            transformOrigin: "401.82px 238.541px",
          }}
          d="M399.58,236.67s4.54-3.36,6.17-1.6-2.82,7.35-5.45,7.44a2.52,2.52,0,0,1-2.76-2.35Z"
        />
        <path
          className="animable"
          id="eladj81x23zfb"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "401.614px 238.705px",
          }}
          d="M404.43,236.64a0,0,0,0,1,0,.07,6.29,6.29,0,0,0-4.37,2.72,1.37,1.37,0,0,1,2.08.3s0,.09-.07.07a1.53,1.53,0,0,0-1.78,0,7.47,7.47,0,0,0-1.21,1c-.13.12-.37,0-.25-.19l0,0C399.51,238.48,402.12,236.1,404.43,236.64Z"
        />
        <path
          className="animable"
          id="eletuvop4do0v"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "386.905px 257.253px",
          }}
          d="M380.33,251.5s.06,0,0,0c-1.52,2.59-4.86,8.69-.47,10.43a10.05,10.05,0,0,0,5.65,0,27,27,0,0,0,5.38-1.81,38.89,38.89,0,0,0,5.65-3,.07.07,0,1,1,.07.12c-1.82,1.13-3.51,2.41-5.44,3.37a23.34,23.34,0,0,1-5.86,2.06,10,10,0,0,1-5.91-.24,3.79,3.79,0,0,1-2.15-4.29A16.6,16.6,0,0,1,380.33,251.5Z"
        />
        <path
          className="animable"
          id="elkyhlssth4"
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "386.175px 258.411px",
          }}
          d="M382.42,249.23l-.06,9,13.55-5.84,1.44,4.23s-15.69,11.66-15.46,10.94l-.46-7.94L375,262.34l5.11-11.44Z"
        />
        <path
          className="animable"
          id="elbz4ewzqm2gt"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "385.521px 259.551px",
          }}
          d="M377.17,256.54c.9-1.86,1.76-3.76,2.75-5.57,0-.07.16-.06.14,0-.37,2-3.87,9.1-4.58,10.86h0c.27-.13,5.9-2.33,5.92-2.26.26,1.34.61,7.12.59,7.63,2.49-1.85,11.81-8.48,14.51-10.09a.08.08,0,0,1,.09.12c-2.37,2.06-14.79,11-14.89,10.95a79.65,79.65,0,0,1-.46-8.37c-1,.56-6.9,3.25-6.8,3A65.06,65.06,0,0,1,377.17,256.54Z"
        />
        <g id="el9jre0g8a4v6">
          <path
            className="animable"
            style={{ opacity: "0.1", transformOrigin: "128.285px 322.152px" }}
            d="M144.49,335.46l-.27.19C135.4,341.56,128,346.23,127,345.83s-4.93-5.56-10.2-12.6l-4.72-34.78c5.17,2.95,9.66,5.58,9.66,5.58l.52-.4Z"
          />
        </g>
        <g id="elpftzxd60pkj">
          <path
            className="animable"
            style={{ opacity: "0.1", transformOrigin: "354.645px 264.519px" }}
            d="M385.26,255.9c-1.3,1.63-3.84,3.43-8,5.28-22.72,10.05-38.06,13.26-44.5,11.5-2.12-.58-5.36-3.48-8.73-7.11Z"
          />
        </g>
      </g>
      <g
        className="animable"
        id="freepik--speech-bubble--inject-18"
        style={{ transformOrigin: "354.885px 198.178px" }}
      >
        <path
          className="animable"
          id="eliutsx07cd"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "354.508px 198.073px",
          }}
          d="M334.37,198.3a19.31,19.31,0,0,0,30.82,15.5l9.46,2.42-3.94-8.81A19.12,19.12,0,0,0,373,198.3a19.32,19.32,0,1,0-38.63,0Z"
        />
        <path
          className="animable"
          id="elf164dzxh7x"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "354.885px 198.277px",
          }}
          d="M334.37,198.3a19.37,19.37,0,0,0,2.93,10.1,20.2,20.2,0,0,0,1.54,2.16,20.74,20.74,0,0,0,1.85,1.9,17.76,17.76,0,0,0,4.37,3,18.54,18.54,0,0,0,5,1.65,21,21,0,0,0,5.26.23,19,19,0,0,0,9.65-3.79l.13-.1.17,0,9.48,2.33-.51.61-4-8.79-.09-.22.11-.21a19.47,19.47,0,0,0,2.22-8.18,19,19,0,0,0-1.58-8.34,20,20,0,0,0-5.05-6.85,19,19,0,0,0-7.57-4,19.31,19.31,0,0,0-8.59-.27,19.12,19.12,0,0,0-15.35,18.73Zm0,0A19.44,19.44,0,0,1,341.76,183a19.53,19.53,0,0,1,30,7.28,19.59,19.59,0,0,1-.6,17.34v-.43l3.9,8.83.37.84-.88-.23-9.44-2.5.3-.06a19.54,19.54,0,0,1-10,3.69,16.23,16.23,0,0,1-2.7,0,18.57,18.57,0,0,1-2.67-.34,19.77,19.77,0,0,1-9.41-4.86,21.09,21.09,0,0,1-1.84-1.94,20.35,20.35,0,0,1-1.53-2.18A19.45,19.45,0,0,1,334.37,198.3Z"
        />
        <path
          className="animable"
          id="el8gac5carmxt"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "344.46px 199.1px",
          }}
          d="M346.16,199.1a1.7,1.7,0,1,1-1.7-1.7A1.7,1.7,0,0,1,346.16,199.1Z"
        />
        <path
          className="animable"
          id="elsnyydtq9nq"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "353.38px 199.1px",
          }}
          d="M355.08,199.1a1.7,1.7,0,1,1-1.7-1.7A1.7,1.7,0,0,1,355.08,199.1Z"
        />
        <path
          className="animable"
          id="elmyub31aftoj"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "362.3px 199.1px",
          }}
          d="M364,199.1a1.7,1.7,0,1,1-1.7-1.7A1.7,1.7,0,0,1,364,199.1Z"
        />
      </g>
      <defs />
    </svg>
  );
};

export default Illus3;
